import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { Slider, Button, InputAdornment, Box } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import ChipInput from 'material-ui-chip-input';
import { useTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import {
  UnitsOperationTypeEnum,
  FormsIdsEnum,
  LeadsStatusEnum,
  LeadTypeIdEnum,
  LeadsClassTypesEnum,
} from '../../Enums';
import {
  GetAdvanceSearchContacts,
  PropertiesAdvanceSearchTest,
  UnitsAdvanceSearchTest,
  GetSensitiveFieldsForUser,
  GetDeveloperContactsAdvanceSearchAPI,
  checkIfAgentIsBlocked,
  CheckPropertyLockAPI,
} from '../../Services';
import { useTranslate } from '../../Hooks';
import {
  getIsFieldWithPermission,
  canEditFieldWithPermissions,
  getIsFieldWithPermissionOnTab,
} from '../../Helper/ExceptionPermissions.Helper';
import {
  LookupRule,
  ContactRule,
  PropertyRule,
  PropertyOrUnitRule,
  VisaRules,
  LookupsEffectedOnRules,
  UserRule,
  TitleRuleV2,
  UserDefaultRule,
  StatusLeadDefaulRule2,
  ListingDateRule2,
  ListingExpiryDateRule2,
  ListingDate,
  BuiltupAreaRule2,
  OnchangeCountryRule2,
  OnchangeCityRule2,
  OnchangeDistrictRule2,
  OnchangeCommunityRule2,
  OnchangeSubCommunityRule2,
  UnitRefNumberRule,
  SekeerLeadRule,
  OnChangeOperationTypeForSeekerLead,
  PassportRule2,
  LiabilityAmount2,
  MortgageDetailsRules2,
  LeadsRule,
  LeadsDefaultRule,
  onChangePropertyRule,
  UnitModelRule,
  ShortageInRule,
  CampaignsDefaultRule,
  CampaignsRule,
  RotationLeadRule,
  EmptyDateFillDefaultRuleV2,
  UnitModelDefaultRule,
  ConstructionDateRule,
  ConstructionDateDefault,
  UnitRentedRule,
  ContactPreferenceRule,
  RentDeposit2,
  UnitRefNumberLeadOwnerRule,
  LeadConvertSizeSqftToSqmRule2,
  LeadConvertSizeSqmToSqftRule2,
  LeadConvertSizeSqftToSqmRuleSlider,
  LeadConvertSizeSqmToSqftRuleSlider,
  LeadConvertSizeSqftToSqmDefaultRule,
  IsMortgageReletedModeOfPaymentRule,
  ModeOfPaymentRule,
  ListingAndRentListingDateRule,
  PropertyPlanRule,
  PropertyOwnerDependingOnRule2,
  PropertyOwnerRule,
  OnPropertyChangeEffectOnUnitRule,
  UnitTypeEffectOnPropertyDefaultRule,
  CompletionDateRule,
  BuiltupAreaSqmRule,
  BuiltupAreaSqmDefaultRule,
  PropertyAddressDefaultRule,
  InquirySendToRotationDefaultRule,
  InquirySendToRotationRule,
  DeveloperContactRule,
  AssignmentLeadRule,
  TradeLicenseDateRule,
} from '../../Rule';
import { UnitMapper as LeaseUnitMapper } from '../../Views/Home/UnitsView/UnitMapper';
import { UnitMapper } from '../../Views/Home/UnitsSalesView/UnitSalesMapper/UnitMapper';
import {
  OnchangePropertyInUnitRuleV2,
  OnChangePropertyOnLeadRule2,
  UnitRule,
} from '../../Rule/UnitRule';
import {
  AutocompleteComponent,
  CheckboxesComponent,
  DatePickerComponent,
  Inputs,
  PhonesComponent,
  RadiosGroupComponent,
} from '../Controls';
import { RepeatedItemDialog } from '../../Views/Home/FormBuilder/Dialogs/RepeatedItemDialog';
import PriceAndPercentage from '../../Views/Home/FormBuilder/Utilities/PriceAndPercentage';
import { ContactsDialog } from '../../Views/Home/FormBuilder/Dialogs/ContactsDialog';
import { AddDeveloperComponent } from '../../Views/Home/DevelopersView';
import { DetailsDialog } from '../../Views/Home/FormBuilder/Dialogs/DetailsDialog';
import { NotHavePolicyToDisplayDataDialog } from '../../Views/Home/FormBuilder/Dialogs/NotHavePolicyToDisplayDataDialog';
import { UploadDialog } from '../../Views/Home/FormBuilder/Dialogs/UploadDialog';
import { MapDialog } from '../../Views/Home/FormBuilder/Dialogs/MapDialog';
import { ModelsUnitsDialog } from '../../Views/Home/FormBuilder/Dialogs/ModelsUnitsDialog';
import { LeadOwnerDialog } from '../../Views/Home/FormBuilder/Dialogs/LeadOwnerDialog';
import {
  CONTACTS,
  PROPERTIES,
  UNITS,
  DEVELOPERS,
} from '../../config/pagesName';
import { UnitModelPopoverComponent } from '../UnitModelPopoverComponent/UnitModelPopoverComponent';
import { RepeatedLinkDialog } from '../../Views/Home/FormBuilder/Dialogs/RepeatedLinkDialog';
import { BathroomsAndBedroomsDefaultRuleV2 } from '../../Rule/BathroomsAndBedroomsDefaultRule';
import { GetParams, showError, showWarn, GlobalTranslate } from '../../Helper';
import { LeaseLeadOwnerDialog } from '../../Views/Home/FormBuilder/Dialogs/LeaseLeadOwnerDialog';
import { FinancialStatusDetails2 } from '../../Rule/FinancialStatusDetailsRules';
import {
  HighPofileManagementDialog,
  PropertyLockManagementDialog,
} from '../Utilities';
import { useSelector } from 'react-redux';
import { MessageConfirmDialog } from '../../SharedComponents';
import {
  EmailInput,
  AddAdditionalTable,
  PhoneNumberInput,
} from '../../Components';
import { FBFieldWrapper } from '../../Components/V2/FormBuilderFields/FBFieldWrapper';
import { useLayoutDetection, useSelectedTheme } from '../../Hooks';
import {
  ReskinningAutocomplete,
  ReskinningDatePicker,
  ReskinningInputs,
} from '../V2';
import { rentalPlanRule } from '../../Rule/rentalPlanRule';
import { CustomMapDialog, ContactUploadDocumentStep } from '../../Components';

// Styles
import useStyles from './styles';

// Icons
import { EyeIcon, PlusIcon, UploadIcon,MapIcon } from '../../assets/icons';

import {
  BranchLocationRule,
  BranchLocationRule2,
} from '../../Rule/BranchLocationRule';
import { useVerticalNav } from '../../Contexts/VerticalNavContext';

export const ConvertJsonV2Component = ({
  item, // item properties & data
  itemValue, // value of item
  allItems, // all items as properties
  allItemsValues, // all items values
  onItemChanged, // on itemValue or on element of properties like enum changed
  onValueChanged, // on itemValue or on element of properties like enum changed
  error, // if this item is invalid (bool)
  helperText, // the error message (string)
  isSubmitted,
  onLoadingsChanged,
  isLoading, // currentItemIsLoadingOrNot
  hideDeposit,
  typeOf,
  isOpenInsideForm,
  parentTranslationPath,
  translationPath,
  itemType,
  unitOpertaionTypeValue,
  canChange,
  formName,
}) => {
  const isUnitProfileRoute =
    window.location.pathname.includes('unit-profile-edit');
  const { t } = useTranslation(['Shared']);
  const { translate } = useTranslate('NewContactsView');

  const styles = useStyles();

  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const isNewLayout = isReskinningLayout && hasNewLayout;
  const {
    theme: { palette },
  } = useSelectedTheme();

  const { id } = item.field;
  const loginResponse = useSelector((state) => state.login.loginResponse);
  const [fielsdWithPermissions, setFielsdWithPermissions] = useState([
    'high_profile_management',
    'angry_bird',
    'listing_agent',
    'rent_listing_agent',
    'contact_consent_main',
    'contact_consent_assets',
    'contact_dncr',
    'property_lock',
    'publishing_requestor',
    'publishing_requester',
    "convolo_project_name"
  ]);
  const context = useVerticalNav()
  const { addNewContact, setAddNewContact } = context || {};

  const [valueIsObjectBefore, setValueIsObjectBefore] = useState([]);
  const [uploadedLogoFile, setUploadedLogoFile] = useState([]);
  const [uploadedImageFile, setUploadedImageFile] = useState([]);
  const [propertyId, setPropertyId] = useState(null);
  const [inputValue, setInputValue] = useState(null);

  const label =
    item && item.data && item.data.caption && item.data.caption !== ''
      ? item.data.caption
      : item.data.title;

  const [isOpenHighProfileMangaement, setIsOpenHighProfileMangaement] =
    useState(false);
  const [isOpenAddDeveloperDialog, setIsOpenAddDeveloperDialog] =
    useState(false);

  const [isOpenPropertyLockMangaement, setIsOpenPropertyLockMangaement] =
    useState(false);
  const [isAgentBlockedDialogOpen, setIsAgentBlockedDialogOpen] =
    useState(false);

  const [unitModelPopoverAttachedWith, setUnitModelPopoverAttachedWith] =
    useState(null);
  const [unitOperationTypeField, setUnitOperationTypeField] = useState(null);
  const [isLeadOwnerForm, setIsLeadOwnerForm] = useState(false);
  const [dataInSideViewButton, setDataInSideViewButton] = useState(null);
  const [isSensitiveLoading2, setIsSensitiveLoading2] = useState(0);
  const [openMapDialog, setOpenMapDialog] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [modelsUnitsDialog, setModelsUnitsDialog] = useState(false);
  const [RepeatedDialog, setRepeatedDialog] = useState(false);
  const [repeatedLinkDialog, setRepeatedLinkDialog] = useState(false);
  const [isOpenContactsDialog, setIsOpenContactsDialog] = useState(false);
  const [isOpenLeadOwnerDialog, setIsOpenLeadOwnerDialog] = useState(false);
  const [leadOwnerValue, setLeadOwnerValue] = useState(null);
  const [isOpenLeaseLeadOwnerDialog, setisOpenLeaseLeadOwnerDialog] =
    useState(false);
  const [LeaseleadOwnerValue, setLeaseLeadOwnerValue] = useState(null);
  const [isOpenItemDetails, setIsOpenItemDetails] = useState(false);
  const [sensitiveFieldsForUser2, setSensitiveFieldsForUser2] = useState(null);
  const [isNotHavePolicyToDisplayData, setIsNotHavePolicyToDisplayData] =
    useState(false);
  const [isLoadingDetailsDialog, setIsLoadingDetailsDialog] = useState(false);
  const [isPropertyLocked, setIsPropertyLocked] = useState(false);

  useLayoutDetection();

  const [emailError, setEmailError] = useState('');
  const [isAdding, setIsAdding] = useState(false);
  const [newValue, setNewValue] = useState(itemValue);
  const [country] = useState('United Arab Emirates');
  const [phoneError, setPhoneError] = useState('');

  useEffect(() => {
    if (
      newValue?.typeId === 18035 ||
      newValue?.typeId === 18027 ||
      newValue?.typeId === 18037
    ) {
      onValueChanged(newValue);
    }
  }, [newValue]);


    useEffect(() => {
    if (isOpenContactsDialog && isNewLayout && !inputValue) {
      setAddNewContact((prev) => ({
        ...prev,
        addContactModalOpened: true,
        shouldOpenAddPage: false,
        isFormBuilderContact: true,
        item,
        itemList: allItems,
        setNewValue: setInputValue,
      }));
    }
  }, [isOpenContactsDialog, isNewLayout]);

  useEffect(() => {
    if (isNewLayout && addNewContact && !addNewContact.addContactModalOpened)
      setIsOpenContactsDialog(false);
  }, [addNewContact]);

  useEffect(() => {
    if (
      (item.field.id === 'rent_listing_expiry_period' &&
        item.data.enum.length === 0) ||
      (item.field.id === 'sale_type' && item.data.enum.length === 0)
    )
      LookupRule(item, allItems);

    CampaignsDefaultRule(
      item,
      onItemChanged,
      (allItemsValues &&
        allItemsValues.campaign_name &&
        allItemsValues.campaign_name.name) ||
        ''
    );
  }, [item, allItems]);

  const GetSensitiveFieldsForUserAPI = useCallback(
    async (formId, sensitiveFieldsForUser) => {
      const allSensitiveFields = await GetSensitiveFieldsForUser(
        formId,
        sensitiveFieldsForUser
      );

      if (
        !(
          allSensitiveFields &&
          allSensitiveFields.status &&
          allSensitiveFields.status !== 200
        )
      ) {
        setSensitiveFieldsForUser2(allSensitiveFields);
        setIsSensitiveLoading2(1);
      } else {
        setSensitiveFieldsForUser2([]);
        setIsSensitiveLoading2(2);
      }
    }
  );

  const onSearchFieldActionClicked = useCallback(async () => {
    setIsLoadingDetailsDialog(true);
    let havePolicyToDisplayDataInSideViewButton = false;
    const itemIndex = allItems.findIndex(
      (effectedItem) =>
        effectedItem.data.title.replace('*', '').trim() === item.data.dependOn
    );
    let l = {};
    if (allItemsValues[itemIndex] && itemValue)
      l = { ...itemValue, itemId: allItemsValues[itemIndex] };
    else if (!allItemsValues[itemIndex] && itemValue)
      l = { ...itemValue, itemId: item && item.data && item.data.searchKey };
    else if (allItemsValues[itemIndex])
      l = { itemId: allItemsValues[itemIndex] };
    else l = { itemId: item && item.data && item.data.searchKey };

    if (l.propertyId) {
      setPropertyId(l.propertyId);
    } else if (itemValue?.propertyId) {
      setPropertyId(itemValue.propertyId);
      l.propertyId = itemValue.propertyId;
    } else if (allItemsValues?.property_name?.id) {
      setPropertyId(allItemsValues.property_name.id);
      l.propertyId = allItemsValues.property_name.id;
    }
    if (item?.data?.searchKey === 'developers') {
      l = {
        itemId: DEVELOPERS,
        type: item?.data?.formId,
        id: itemValue?.developerId,
      };
      const body = {
        criteria: {
          Ids: [{ searchType: 1, value: l && l.id }],
        },
        filterBy: 'createdOn',
        orderBy: 2,
      };
      const res = await GetDeveloperContactsAdvanceSearchAPI(
        { pageIndex: 0, pageSize: 2 },
        body
      );
      if (!(res && res.status && res.status !== 200)) {
        if (res && res.totalCount > 0) {
          if (
            res &&
            res.result &&
            res.result.length &&
            res.result[0].developerJson
          ) {
            const developerJson =
              res &&
              res.result &&
              res.result.length &&
              res.result[0] &&
              res.result[0].developerJson;
            havePolicyToDisplayDataInSideViewButton = true;
            if (havePolicyToDisplayDataInSideViewButton) {
              setDataInSideViewButton(developerJson);
            }
          }
        } else {
          havePolicyToDisplayDataInSideViewButton = false;
          setDataInSideViewButton(null);
        }
      } else {
        havePolicyToDisplayDataInSideViewButton = false;
        setDataInSideViewButton(null);
      }
    }
    if (l.itemId && l.itemId.toLowerCase().includes('contact')) {
      l.itemId = CONTACTS;

      if (item.data.dependOn === 'company') l.type = 2;
      if (!l.type) l.type = 1;
      const body = {
        criteria: {
          Ids: [{ searchType: 1, value: (l && l.id) ||  inputValue?.id }],
        },
        filterBy: 'createdOn',
        orderBy: 2,
      };
      const res = await GetAdvanceSearchContacts(
        { pageIndex: 0, pageSize: 2 },
        body
      );
      if (!(res && res.status && res.status !== 200)) {
        if (res && res.totalCount > 0) {
          if (
            res &&
            res.result &&
            res.result.length &&
            res.result[0].contactJson
          ) {
            const contactJson = JSON.parse(
              res &&
                res.result &&
                res.result.length &&
                res.result[0] &&
                res.result[0].contactJson
            );
            havePolicyToDisplayDataInSideViewButton = true;
            if (havePolicyToDisplayDataInSideViewButton) {
              setDataInSideViewButton(contactJson);
              setIsOpenItemDetails(true);
              setTimeout(() => {
                GetSensitiveFieldsForUserAPI(
                  contactJson &&
                    contactJson.contact &&
                    contactJson.contact.contact_type_id,
                  { key: 'contact', id: res.result[0].contactId }
                );
              }, 200);
            }
          }
        } else {
          havePolicyToDisplayDataInSideViewButton = false;
          setDataInSideViewButton(null);
        }
      } else {
        havePolicyToDisplayDataInSideViewButton = false;
        setDataInSideViewButton(null);
      }
    }

    if (l.itemId && l.itemId.toLowerCase() === 'property') {
      l.itemId = PROPERTIES;
      l.type = '1';
      const body = {
        criteria: {
          Ids: [{ searchType: 1, value: l && l.id }],
        },
        filterBy: 'createdOn',
        orderBy: 2,
      };

      const res = await PropertiesAdvanceSearchTest(
        { pageIndex: 0, pageSize: 2 },
        body
      );
      if (!(res && res.status && res.status !== 200)) {
        if (res && res.totalCount > 0) {
          if (
            res &&
            res.result &&
            res.result.length &&
            res.result[0].propertyJson
          ) {
            const propertyJson = JSON.parse(
              res &&
                res.result &&
                res.result.length &&
                res.result[0].propertyJson
            );
            havePolicyToDisplayDataInSideViewButton = true;
            if (havePolicyToDisplayDataInSideViewButton) {
              setDataInSideViewButton(propertyJson);
              setTimeout(() => {
                GetSensitiveFieldsForUserAPI(
                  FormsIdsEnum.properties.id,
                  propertyJson && {
                    key: 'property',
                    id: res.result[0].propertyId,
                  }
                );
              }, 200);
            }
          }
        } else {
          havePolicyToDisplayDataInSideViewButton = false;
          setDataInSideViewButton(null);
        }
      } else {
        havePolicyToDisplayDataInSideViewButton = false;
        setDataInSideViewButton(null);
      }
    }
    if (l.itemId && l.itemId.toLowerCase() === 'unit') {
      const operationType =
        (allItemsValues.unit_ref_number &&
          allItemsValues.unit_ref_number.operation_type_name) ||
        (allItemsValues.lead_operation &&
        allItemsValues.lead_operation === 'Seller'
          ? 'Sale'
          : 'Rent');
      localStorage.setItem(
        'unitModelRelatedData',
        JSON.stringify({
          operation_type: {
            lookupItemName:
              (itemValue && itemValue.operationType) || operationType || null,
          },
        })
      );
      l.itemId = UNITS;
      l.operationType =
        (itemValue && itemValue.operationType) || operationType || null;
      const body = {
        OperationType:
          l && l.operationType && l.operationType === 'Sale' ? 'Sale' : 'Lease',
        criteria: {
          unitId: [{ searchType: 1, value: l && l.id }],
        },
        filterBy: 'createdOn',
        orderBy: 2,
      };

      const res = await UnitsAdvanceSearchTest(
        { pageIndex: 0, pageSize: 2 },
        body
      );
      if (!(res && res.status && res.status !== 200)) {
        if (res && res.totalCount > 0) {
          if (
            res &&
            res.result &&
            res.result.length &&
            res.result[0] &&
            res.result[0].unitJson
          ) {
            const unitJson = JSON.parse(
              res && res.result && res.result.length && res.result[0].unitJson
            );

            const unitPropertyId =
              unitJson?.unit?.property_name?.id || res.result[0]?.propertyId;
            if (unitPropertyId) {
              setPropertyId(unitPropertyId);
              getIsPropertyLocked(true, unitPropertyId);
            }

            setUnitOperationTypeField(
              unitJson.unit &&
                unitJson.unit.operation_type &&
                unitJson.unit.operation_type.lookupItemId
            );
            const unitDatails =
              operationType === UnitsOperationTypeEnum.sale.key ||
              operationType === UnitsOperationTypeEnum.rentAndSale.key
                ? UnitMapper({ ...unitJson, ...res.result[0] })
                : LeaseUnitMapper({ ...unitJson, ...res.result[0] });
            localStorage.setItem(
              'unitModelRelatedData',
              JSON.stringify(unitDatails)
            );
            havePolicyToDisplayDataInSideViewButton = true;
            if (havePolicyToDisplayDataInSideViewButton) {
              const unitId = l && l.id;

              setDataInSideViewButton(unitJson);
              setTimeout(() => {
                GetSensitiveFieldsForUserAPI(
                  FormsIdsEnum.units.id,
                  unitJson && {
                    key: 'unit',
                    id: res.result[0] && res.result[0].unitId,
                  }
                );
              }, 200);
            }
          }
        } else {
          havePolicyToDisplayDataInSideViewButton = false;
          setDataInSideViewButton(null);
        }
      } else {
        havePolicyToDisplayDataInSideViewButton = false;
        setDataInSideViewButton(null);
      }
    }
    localStorage.setItem('current', JSON.stringify(l));
    if (item?.data?.searchKey === 'developers' && !itemValue)
      setIsOpenAddDeveloperDialog(true);
    else if (!itemValue) setIsOpenContactsDialog(true);
    else if (havePolicyToDisplayDataInSideViewButton)
      setIsOpenItemDetails(true);
    else if (!havePolicyToDisplayDataInSideViewButton)
      setIsNotHavePolicyToDisplayData(true);
    if (havePolicyToDisplayDataInSideViewButton && inputValue) {
      setIsOpenItemDetails(true);
    }
    setIsLoadingDetailsDialog(false);
  }, [
    allItems,
    allItemsValues,
    item.data.dependOn,
    item.data.searchKey,
    itemValue,
    inputValue
  ]);


  const openUnitModelPopoverHandler = useCallback((event) => {
    setUnitModelPopoverAttachedWith(event.currentTarget);
  }, []);

  const onPopoverClose = useCallback(() => {
    setUnitModelPopoverAttachedWith(null);
  }, []);

  useEffect(() => {
    if (id === 'title')
      setTimeout(() => {
        TitleRuleV2(id, onValueChanged, item, allItems, itemValue);
      }, 2000);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const leadStatus = localStorage.getItem('leadStatus');
      if (leadStatus && (id === 'status' || id === 'lead_stage')) {
        const leadStatusJson = JSON.parse(leadStatus);
        if (
          item.field.id === 'status' &&
          leadStatusJson &&
          (leadStatusJson.lookupItemName === 'Closed' ||
            +LeadsStatusEnum.Closed.status === +leadStatusJson.lookupItemId)
        )
          item.data.isReadonly = true;
        else if (
          item.field.id === 'status' &&
          leadStatusJson &&
          (leadStatusJson?.lookupItemName === 'Open' ||
            +LeadsStatusEnum.Open.status === +leadStatusJson?.lookupItemId)
        )
          item.data.isReadonly = false;
        else if (
          item.field.id === 'lead_stage' &&
          leadStatusJson &&
          (leadStatusJson?.lookupItemName === 'Closed' ||
            +LeadsStatusEnum.Closed.status === +leadStatusJson?.lookupItemId)
        )
          item.data.isReadonly = true;
        else if (
          item.field.id === 'lead_stage' &&
          leadStatusJson &&
          (leadStatusJson?.lookupItemName === 'Open' ||
            +LeadsStatusEnum.Open.status === +leadStatusJson?.lookupItemId)
        )
          item.data.isReadonly = false;
      }
    }, 300);
  }, [item]);

  const getStatusValue = () => {
    if (item.field.id === 'referredto') {
      const { status } = allItemsValues;
      if (status) return !!(status && status.lookupItemName === 'Closed');
    }
    return false;
  };

  const disableIsMortgageInTenant = () => {
    if (
      item.field.id === 'is_mortgage' &&
      item.data.specialKey === 'is_mortgage_seeker_lead' &&
      allItemsValues &&
      allItemsValues.operation_type &&
      allItemsValues.operation_type.lookupItemName === 'Rent'
    )
      return true;
    if (
      item.field.id === 'mode_of_payment' &&
      item.data.DtoName === 'mode_of_payment_seeker_lead' &&
      allItemsValues &&
      allItemsValues.operation_type &&
      allItemsValues.operation_type.lookupItemName === 'Rent'
    )
      return true;

    return false;
  };

  const getStatusValue2 = () => {
    if (item.field.id === 'status') {
      const { status } = allItemsValues;
      if (status && status.lookupItemName === 'Closed') return true;
    }
    return false;
  };

  const disableQualification = () => {
    if (
      item.field.id === 'qualification' &&
      item.data.specialKey !== 'contact-qualification'
    )
      return true;
    else return false;
  };

  const disableListingExpiryPeriod = () => {
    if (
      item.field.id === 'listing_expiry_period' &&
      !allItemsValues?.listing_date
    )
      return true;
    else if (
      item.field.id === 'rent_listing_expiry_period' &&
      !allItemsValues?.rent_listing_date
    )
      return true;
    else return false;
  };

  const disableName = () => {
    if (item.field.id === 'developer_name' || item.field.id === 'vendor_name' ||  item.field.id === 'referred_by_contact')
      return true;
    else return false;
  };

  const disableRatingLead = () => {
    if (item.field.id === 'rating' && item.data.specialKey === 'rating_lead')
      return true;
    else return false;
  };

  const disableOperationType = () => {
    if (
      item.field.id === 'operation_type' &&
      item.data.specialKey &&
      item.data.specialKey === 'UnitOperationType' &&
      unitOpertaionTypeValue &&
      unitOpertaionTypeValue === UnitsOperationTypeEnum.rentAndSale.key
    )
      return true;
    return false;
  };

  const disableChangePropertyAge = () => {
    if (
      item.field.id === 'property_age' &&
      allItemsValues &&
      allItemsValues.completion_date
    )
      return true;
    else return false;
  };

  const fieldWithPermissionsToEdit = () => {
    if (fielsdWithPermissions.some((f) => f === id))
      return !canEditFieldWithPermissions(id, itemType);

    if (formName && formName === 'Developers')
      return !getIsFieldWithPermissionOnTab('Developers', item);

    return false;
  };

  const getSendLeadToRotationSelected = () => {
    const sendToRotationIndex = allItems.indexOf(
      allItems.find((f) => f.field.id === 'send_to_rotation')
    );
    if (
      sendToRotationIndex !== -1 &&
      item.field.id === 'referredto' &&
      allItemsValues &&
      allItemsValues.send_to_rotation &&
      allItemsValues.send_to_rotation === 'Yes'
    )
      return true;
    else if (
      sendToRotationIndex !== -1 &&
      item.field.id === 'assign_to' &&
      allItemsValues &&
      allItemsValues.send_to_rotation &&
      allItemsValues.send_to_rotation === 'Yes'
    )
      return true;

    return false;
  };

  const getSmartAssignmentSelected = () => {
    const smartAssignment = allItems.indexOf(
      allItems.find((f) => f.field.id === 'smart_assignment')
    );
    if (
      smartAssignment !== -1 &&
      item.field.id === 'referredto' &&
      allItemsValues?.smart_assignment === 'Yes'
    )
      return true;

    return false;
  };

  const disableUnitNumberOfPayments = () => {
    const unitNumberOfPaymentsIndex = allItems.indexOf(
      allItems.find((f) => f.field.id === 'rental_plan')
    );
    if (
      unitNumberOfPaymentsIndex !== -1 &&
      item.field.id === 'number_of_payments' &&
      (!allItemsValues?.rental_plan ||
        allItemsValues?.rental_plan === 'Monthly')
    )
      return true;
    return false;
  };

  const getLeadOperationValue = () => {
    if (item.field.id === 'lead_operation') return true;
    return false;
  };

  const saleTypeOwnerlead = () => {
    if (
      item.field.id === 'sale_type' &&
      item.data.specialKey === 'sale_type_lead_owner' &&
      allItemsValues &&
      allItemsValues.unit_ref_number
    )
      return true;
    return false;
  };

  const getIsLeadAuditor = () => {
    if (item.field.id === 'lead_auditor') return true;
    return false;
  };

  const disableLead = () => {
    if (
      item &&
      item.field &&
      item.field.id === 'lead' &&
      item.data.searchableKey === 'lead_inquiry'
    )
      return true;
    return false;
  };

  const financialStatusDetailsRules = () => {
    if (
      (item.field.id === 'auto_loan_outstanding_balance' ||
        item.field.id === 'auto_loan_monthly_installment') &&
      (allItemsValues.has_auto_loan === 'No' || !allItemsValues.has_auto_loan)
    )
      return true;

    if (
      (item.field.id === 'personal_loan_outstanding_balance' ||
        item.field.id === 'personal_loan_monthly_installment') &&
      (allItemsValues.has_personal_loan === 'No' ||
        !allItemsValues.has_personal_loan)
    )
      return true;

    if (
      (item.field.id === 'home_loan_outstanding_balance' ||
        item.field.id === 'home_loan_monthly_installment') &&
      (allItemsValues.has_home_loan === 'No' || !allItemsValues.has_home_loan)
    )
      return true;

    if (
      (item.field.id === 'credit_card_outstanding_balance' ||
        item.field.id === 'credit_card_monthly_installment') &&
      (allItemsValues.has_credit_card === 'No' ||
        !allItemsValues.has_credit_card)
    )
      return true;
    if (
      (item.field.id === 'other_liabilities_outstanding_balance' ||
        item.field.id === 'other_liabilities_monthly_installment') &&
      (allItemsValues.has_other_liabilities === 'No' ||
        !allItemsValues.has_other_liabilities)
    )
      return true;

    if (item.field.id === 'liability_amount') return true;

    return false;
  };

  const customerProfileSelected = () => {
    const customerProfileIndex =
      allItems &&
      allItems.indexOf(allItems.find((f) => f.field.id === 'customer_profile'));
    if (
      customerProfileIndex !== -1 &&
      allItems &&
      allItems[customerProfileIndex].data.isReadonly
    )
      return true;

    if (
      item.field.id === 'confirmed_employee' &&
      !allItemsValues.customer_profile
    )
      return true;

    if (item.field.id === 'allowance' && !allItemsValues.customer_profile)
      return true;

    if (
      item.field.id === 'liability_from_company' &&
      !allItemsValues.customer_profile
    )
      return true;

    if (
      item.field.id === 'company_name' &&
      !allItemsValues.customer_profile &&
      item.data.specialKey !== 'contact_company_name' &&
      item.data.specialKey !== 'vendor_company_name'
    )
      return true;
    if (item.field.id === 'monthly_income' && !allItemsValues.customer_profile)
      return true;

    if (item.field.id === 'yearly_income' && !allItemsValues.customer_profile)
      return true;
    if (
      item.field.id === 'date_of_establishment' &&
      !allItemsValues.customer_profile
    )
      return true;
    if (
      item.field.id === 'number_of_partner' &&
      !allItemsValues.customer_profile
    )
      return true;

    return false;
  };

  const listingExpiryDateSelected = () => {
    const listingExpiryDate =
      allItems && allItems.indexOf((f) => f.field.id === 'listing_expiry_date');
    const listingExpiryDateIndex = allItems.indexOf(
      allItems.find(
        (f) =>
          f.field.id === 'listing_expiry_date' ||
          f.field.id === 'listing_expiry-date'
      )
    );

    if (
      item.field.id === 'listing_expiry_date' &&
      listingExpiryDateIndex !== -1 &&
      allItemsValues['listing_expiry_period']
    )
      return true;
    else if (
      item.field.id === 'listing_expiry_date' &&
      listingExpiryDate !== -1 &&
      !allItemsValues['listing_expiry_period']
    )
      return false;

    const rentListingExpiryDateIndex = allItems.indexOf(
      allItems.find(
        (f) =>
          f.field.id === 'rent_listing_expiry_date' ||
          f.field.id === 'rent_listing-expiry-date'
      )
    );

    if (
      item.field.id === 'rent_listing_expiry_date' &&
      rentListingExpiryDateIndex !== -1 &&
      allItemsValues['rent_listing_expiry_period']
    )
      return true;
    else if (
      item.field.id === 'rent_listing_expiry_date' &&
      rentListingExpiryDateIndex !== -1 &&
      !allItemsValues['rent_listing_expiry_period']
    )
      return false;

    return false;
  };

  const disableUnitRefNumber = () => {
    if (
      item.field.id === 'unit_ref_number' &&
      item.data.DtoName === 'unit_ref_number_owner_lead'
    ) {
      if (item.data.isReadonly) return true;

      if (!item.data.isReadonly && item.data && item.data.valueToEdit)
        return true;

      if (!item.data.isReadonly && !item.data.valueToEdit) return false;
    }
    return false;
  };

  const getDataEnumList = (item) => {
    let list = [];
    if (
      item.field.id === 'operation_type' &&
      item.data.specialKey &&
      item.data.specialKey === 'UnitOperationType'
    ) {
      if (item.data.isReadonly) {
        list = item.data.enum.filter(
          (ot) => ot.lookupItemName === 'SaleAndRent'
        );
        return list;
      }

      const operationTypeValue =
        (allItemsValues &&
          allItemsValues.operation_type &&
          allItemsValues.operation_type) ||
        null;
      if (
        operationTypeValue &&
        (operationTypeValue.lookupItemId === UnitsOperationTypeEnum.sale.key ||
          operationTypeValue.lookupItemName === 'Sale')
      )
        list = item.data.enum.filter(
          (ot) =>
            ot.lookupItemName === 'Sale' || ot.lookupItemName === 'SaleAndRent'
        );
      else if (
        operationTypeValue &&
        (operationTypeValue.lookupItemId === UnitsOperationTypeEnum.rent.key ||
          operationTypeValue.lookupItemName === 'Rent')
      )
        list = item.data.enum.filter(
          (ot) =>
            ot.lookupItemName === 'Rent' || ot.lookupItemName === 'SaleAndRent'
        );
      else if (
        operationTypeValue &&
        operationTypeValue.lookupItemId ===
          UnitsOperationTypeEnum.rentAndSale.key &&
        itemType &&
        itemType.name === 'leaseUnit'
      )
        list = item.data.enum.filter(
          (ot) =>
            ot.lookupItemName === 'Rent' || ot.lookupItemName === 'SaleAndRent'
        );
      else if (
        operationTypeValue &&
        operationTypeValue.lookupItemId ===
          UnitsOperationTypeEnum.rentAndSale.key &&
        itemType &&
        itemType.name === 'saleUnit'
      )
        list = item.data.enum.filter(
          (ot) =>
            ot.lookupItemName === 'Sale' || ot.lookupItemName === 'SaleAndRent'
        );
      else if (!operationTypeValue && itemType && itemType.name === 'saleUnit')
        list = item.data.enum.filter(
          (ot) =>
            ot.lookupItemName === 'Sale' || ot.lookupItemName === 'SaleAndRent'
        );
      else if (!operationTypeValue && itemType && itemType.name === 'leaseUnit')
        list = item.data.enum.filter(
          (ot) =>
            ot.lookupItemName === 'Rent' || ot.lookupItemName === 'SaleAndRent'
        );

      return list;
    } else if (id === 'lead_type') {
      const filterlist = [
        {
          lookupItemId: 495,
          lookupItemName: 'Owner',
          lookupItemCode: null,
          description: '495',
          order: 99,
          parentLookupItemId: null,
          parentLookupItemName: null,
          parentLookupTypeId: 0,
          parentLookupTypeName: null,
          isEditable: false,
          lookupItemParents: null,
          createdBy: null,
          createdByName: null,
          createdOn: null,
          updatedBy: null,
          updatedByName: null,
          updateOn: null,
        },
      ];
      return filterlist;
    } else if (id === 'contact_preference') {
      const list = [];
      const addSelecAll = {
        lookupItemId: 1993,
        lookupItemName: 'Select All',
      };

      list.push(addSelecAll);
      item.data.enum.map((item1) => {
        list.push(item1);
      });

      return list;
    }
    return item.data.enum;
  };

  const getIsUpdateCloseResonAndRemarks = () => {
    if (id === 'close_reason') {
      const leadStatus = localStorage.getItem('leadStatus');
      if (leadStatus) {
        const leadStatusJson = JSON.parse(leadStatus);
        if (leadStatusJson && leadStatusJson.lookupItemName === 'Closed')
          return true;
      }
    } else if (id === 'closing_remarks')
      return !(
        allItemsValues.status &&
        allItemsValues.status.lookupItemName === 'Closed'
      );

    return false;
  };

  const cannotBeModifiedFieldValues = () => {
    if (
      item.field.id === "connection_from_name" ||
      item.field.id === "connection_from-name"
    )
      return true;

    return false;
  };

  const getIsPropertyLocked = async (check = false, id = null) => {
    const propertyIdToCheck =
      id || allItemsValues?.property_name?.id || propertyId;

    if (
      check ||
      (isUnitProfileRoute &&
        propertyIdToCheck &&
        ['unit_number', 'phase_number', 'building_number'].includes(
          item.field.id
        ))
    ) {
      if (propertyIdToCheck) {
        const res = await CheckPropertyLockAPI(propertyIdToCheck);
        if (!(res && res.status && res.status !== 200)) {
          setIsPropertyLocked(res);
        } else {
          setIsPropertyLocked(false);
        }
      }
    }
  };

  const displyTextField = () => {
    if (
      id !== 'rented_value' &&
      item.field.FieldType === 'textField' &&
      (item.data.specialKey === 'currency' ||
        item.data.specialKey === 'size' ||
        item.data.specialKey === 'decimal')
    )
      return true;

    if (
      item.field.FieldType === 'textField' &&
      item.data.specialKey === 'currency' &&
      id === 'rented_value' &&
      allItemsValues &&
      allItemsValues.is_unit_rented &&
      allItemsValues.is_unit_rented === 'Yes'
    )
      return true;

    return false;
  };

  const notUpdateInsideForm = () => {
    if (
      isOpenInsideForm &&
      (item.field.id === 'first_name' ||
        item.field.id === 'last_name' ||
        item.field.id === 'property_name' ||
        (item.field.id === 'company_name' &&
          item.data.specialKey !== 'vendor_company_name' &&
          item.data.specialKey === 'contact_company_name'))
    )
      return true;
    return false;
  };

  const displySelectFields = () => {
    if (
      item.field.id === 'sale_type' &&
      item.data.specialKey === 'sale_type_lead_owner'
    ) {
      const saleTypeIndex = allItems.indexOf(
        allItems.find(
          (f) =>
            f.field.id === 'sale_type' &&
            f.data.specialKey === 'sale_type_lead_owner'
        )
      );
      const leadOperationIndex = allItems.indexOf(
        allItems.find((f) => f.field.id === 'lead_operation')
      );

      if (
        saleTypeIndex !== -1 &&
        leadOperationIndex !== -1 &&
        allItemsValues.lead_operation &&
        allItemsValues.lead_operation === 'Seller'
      )
        return true;

      return false;
    }
    if (item.field.id === 'close_reason')
      return !!(
        allItemsValues &&
        allItemsValues.status &&
        allItemsValues.status.lookupItemName === 'Closed'
      );

    return false;
  };

  const displySearchFields = () => {
    const field = item && item.data && item.data.DtoName;
    const fielsdHavePermissions = [
      'send_to_rotation_listing_shortage',
      'assign_to_listing_shortage',
      'send_to_rotation_zero_matching_sale',
      'assign_to_zero_matching_sale',
      'assign_to_zero_matching_lease',
      'send_to_rotation_zero_matching_lease',
    ];

    if (field && fielsdHavePermissions.some((f) => f === field))
      return getIsFieldWithPermission(field);
    if (
      item.field.id === 'sale_type' &&
      item.data.specialKey === 'sale_type_seeker_lead' &&
      allItemsValues &&
      ((allItemsValues.operation_type &&
        (allItemsValues.operation_type.lookupItemName === 'Rent' ||
          allItemsValues.operation_type.lookupItemId === 492)) ||
        !allItemsValues.operation_type)
    )
      return false;

    return true;
  };

  const disableContactRate = () => {
    if (item.field.id === 'contact_rate') return true;
    else return false;
  };

  const isSelectDisallowed = (selectedOption) => {
    let isDisallowedOpt = false;

    if (item.field.id === 'close_reason') {
      isDisallowedOpt =
        selectedOption?.lookupItemName === 'Lead Close by Transaction';
    }

    if (isDisallowedOpt)
      showWarn(
        GlobalTranslate.t(
          'Shared:selecting-this-option-manually-is-not-allowed'
        )
      );
    return isDisallowedOpt;
  };

  useEffect(() => {
    if (
      (item.field.id === 'bathrooms' && item.field.FieldType === 'select') ||
      (item.field.id === 'bedrooms' && item.field.FieldType === 'select')
    ) {
      setTimeout(() => {
        BathroomsAndBedroomsDefaultRuleV2(
          item,
          onValueChanged,
          allItems,
          allItemsValues
        );
      }, 500);
    }

    if (item.field.id === 'size_sqft')
      LeadConvertSizeSqftToSqmDefaultRule(
        item,
        allItemsValues,
        onValueChanged,
        allItems
      );
    if (item.field.id === 'builtup_area_sqft')
      BuiltupAreaSqmDefaultRule(
        allItemsValues && allItemsValues.builtup_area_sqft,
        onValueChanged,
        2,
        allItems,
        allItemsValues
      );

    if (
      item.field.id === 'referredto' &&
      item.data.DtoName === LeadTypeIdEnum.Seeker.name
    )
      UserRule(
        item,
        null,
        onItemChanged,
        allItems,
        allItemsValues,
        1,
        2,
        onValueChanged
      );

    if (item.field.id === 'inquiry_unit_model')
      UnitModelDefaultRule(item, onItemChanged, allItems, allItemsValues);

    if (item.field.FieldType === 'alt-date' && item.data.valueToEdit === '') {
      setTimeout(() => {
        EmptyDateFillDefaultRuleV2(item, onValueChanged);
      }, 500);
    }

    if (item.field.id === 'construction_date') {
      if (allItemsValues && allItemsValues.construction_date)
        ConstructionDateDefault(
          id,
          allItems,
          allItemsValues.construction_date,
          onValueChanged,
          allItemsValues
        );
    }

    if (item.field.id === 'customer_profile' && !item.data.isReadonly)
      MortgageDetailsRules2(
        item,
        allItemsValues.customer_profile,
        onValueChanged,
        allItems,
        allItemsValues
      );

    if (
      item.field.id === 'property_name' &&
      item.data.DtoName === 'property_seeker_lead' &&
      (allItemsValues.leadClass === LeadsClassTypesEnum.tenant.name ||
        allItemsValues.leadClass === LeadsClassTypesEnum.buyer.name)
    ) {
      setTimeout(() => {
        SekeerLeadRule(allItems, allItemsValues);
      }, 500);
    }
    setTimeout(() => {
      if (item.field.id === 'status') {
        getStatusValue();
        getStatusValue2();
        getIsUpdateCloseResonAndRemarks();
      }
    }, 700);
  }, []);

  useEffect(() => {
    if (item.field.id === 'listing_date') {
      if (allItemsValues && allItemsValues.listing_date) {
        setTimeout(() => {
          ListingDate(id, allItems, allItemsValues.listing_date);
        }, 500);
      }
    }
    if (item.field.id === 'rent_listing_date') {
      if (allItemsValues && allItemsValues.rent_listing_date) {
        setTimeout(() => {
          ListingDate(id, allItems, allItemsValues.rent_listing_date);
        }, 500);
      }
    }
    if (
      (item.field.id === 'unit_type' &&
        item.data.DtoName === 'unit_type_unit') ||
      (item.field.id === 'unit_type' &&
        item.data.DtoName === 'inquires_unit_type')
    ) {
      setTimeout(() => {
        UnitTypeEffectOnPropertyDefaultRule(
          item,
          onItemChanged,
          allItemsValues,
          allItems
        );
      }, 200);
    }
    if (
      item.field.id === 'property' &&
      item.data.DtoName === 'property_inquiries'
    )
      setTimeout(() => {
        PropertyAddressDefaultRule(onItemChanged, allItemsValues, allItems);
      }, 200);

    if (item.data.multi && item.data.multi === 'true') {
      if (itemValue && itemValue.constructor === Object)
        setValueIsObjectBefore([itemValue]);
      else if (!itemValue) setValueIsObjectBefore([]);
    }
    if (
      item.field.id === 'send_to_rotation' &&
      item.data.specialKey === 'sendInquiryToRotation'
    ) {
      setTimeout(() => {
        InquirySendToRotationDefaultRule(
          item,
          allItems,
          allItemsValues,
          onValueChanged
        );
      }, 200);
    }
  }, [item.field.id]);

  useEffect(() => {
    const sellingPriceAgencyFeeIndex = allItems.indexOf(
      allItems.find((f) => f.field.id === 'selling_price_agency_fee')
    );
    if (
      (id === 'seller_has_paid' || id === 'selling_price_agency_fee') &&
      sellingPriceAgencyFeeIndex !== -1 &&
      !allItems[sellingPriceAgencyFeeIndex].data.isReadonly
    ) {
      const sellerhaspaid =
        allItemsValues && allItemsValues.seller_has_paid
          ? allItemsValues.seller_has_paid
          : 0;
      const sellingpriceagencyfee =
        allItemsValues && allItemsValues.selling_price_agency_fee
          ? allItemsValues.selling_price_agency_fee.salePrice
          : 0;
      const sub = sellingpriceagencyfee - sellerhaspaid;

      setTimeout(() => {
        onValueChanged(sub, 0, 'amount_due_to_developer');
      }, 300);
    } else if (
      id === 'email_address' &&
      allItemsValues &&
      allItemsValues.email_address
    ) {
      if (allItemsValues.email_address.email === '')
        onValueChanged(null, 0, 'email_address');
    }

    if (!isSubmitted && item.data.addressType) {
      setTimeout(() => {
        if (
          item &&
          item.data.enum.length === 0 &&
          item.data.uiType === 'select' &&
          !item.data.isFillData
        )
          LookupRule(item, allItems);
      }, 3800);
    } else if (isSubmitted && item.data.uiType === 'select' && error)
      LookupRule(item, allItems);

    const propertyOwnerIndex = allItems.indexOf(
      allItems.find((f) => f.field.id === 'property_owner')
    );

    if (
      propertyOwnerIndex &&
      allItemsValues &&
      allItemsValues.property_plan &&
      (allItemsValues.property_plan.lookupItemName === 'Off-Plan Primary' ||
        allItemsValues.property_plan.lookupItemName === 'Off-Plan')
    ) {
      if (allItems[propertyOwnerIndex] && allItems[propertyOwnerIndex].field) {
        allItems[propertyOwnerIndex].field.isRequired = true;
        allItems[propertyOwnerIndex].data.title = 'Property Owner *';
      }
    } else if (
      propertyOwnerIndex &&
      allItemsValues &&
      allItemsValues.property_plan &&
      (allItemsValues.property_plan.lookupItemName === 'Completed' ||
        allItemsValues.property_plan.lookupItemName === 'Pre Launch')
    ) {
      if (allItems[propertyOwnerIndex] && allItems[propertyOwnerIndex].field) {
        allItems[propertyOwnerIndex].field.isRequired = false;
        allItems[propertyOwnerIndex].data.title = 'Property Owner';
      }
    }
    if (
      item.field.id === 'vendor_email' &&
      (!allItemsValues['vendor_email'] ||
        allItemsValues['vendor_email'].email === '') &&
      allItemsValues['vendor_name']
    ) {
      setTimeout(() => {
        onValueChanged(
          allItemsValues['vendor_name']?.email_address
            ? {
                email: allItemsValues['vendor_name'].email_address,
                typeId: 18040,
              }
            : null,
          0,
          'vendor_email'
        );
      }, 200);
    }
    const listingExpiryPeriodIndex = allItems.indexOf(
      allItems.find(
        (f) =>
          f.field.id === 'listing_expiry-period' ||
          f.field.id === 'listing_expiry_period'
      )
    );

    const listingExpiryDateIndex = allItems.indexOf(
      allItems.find(
        (f) =>
          f.field.id === 'listing_expiry_date' ||
          f.field.id === 'listing_expiry-date'
      )
    );

    if (
      item.field.id === 'listing_date' ||
      item.field.id === 'listing_expiry_date' ||
      item.field.id === 'listing_expiry_period'
    ) {
      if (listingExpiryPeriodIndex !== -1) {
        allItems[listingExpiryPeriodIndex].field.isRequired =
          allItemsValues['listing_date'] &&
          !allItemsValues['listing_expiry_date']
            ? true
            : false;
        allItems[listingExpiryPeriodIndex].data.title =
          allItemsValues['listing_date'] &&
          !allItemsValues['listing_expiry_date']
            ? 'Listing Expiry Period *'
            : 'Listing Expiry Period';
      }

      if (listingExpiryDateIndex !== -1) {
        allItems[listingExpiryDateIndex].field.isRequired = allItemsValues[
          'listing_date'
        ]
          ? true
          : false;
        allItems[listingExpiryDateIndex].data.title = allItemsValues[
          'listing_date'
        ]
          ? 'Listing Expiry Date *'
          : 'Listing Expiry Date';
      }
    }
    const rentListingExpiryPeriodIndex = allItems.indexOf(
      allItems.find(
        (f) =>
          f.field.id === 'rent_listing_expiry_period' ||
          f.field.id === 'rent_listing-expiry-period'
      )
    );

    const rentListingExpiryDateIndex = allItems.indexOf(
      allItems.find(
        (f) =>
          f.field.id === 'rent_listing_expiry_date' ||
          f.field.id === 'rent_listing-expiry-date'
      )
    );

    if (
      item.field.id === 'rent_listing_date' ||
      item.field.id === 'rent_listing_expiry_date' ||
      item.field.id === 'rent_listing_expiry_period'
    ) {
      if (rentListingExpiryPeriodIndex !== -1) {
        allItems[rentListingExpiryPeriodIndex].field.isRequired =
          allItemsValues['rent_listing_date'] &&
          !allItemsValues['rent_listing_expiry_date']
            ? true
            : false;
        allItems[rentListingExpiryPeriodIndex].data.title =
          allItemsValues['rent_listing_date'] &&
          !allItemsValues['rent_listing_expiry_date']
            ? 'Rent Listing Expiry Period *'
            : 'Rent Listing Expiry Period';
      }

      if (rentListingExpiryDateIndex !== -1) {
        allItems[rentListingExpiryDateIndex].field.isRequired = allItemsValues[
          'rent_listing_date'
        ]
          ? true
          : false;
        allItems[rentListingExpiryDateIndex].data.title = allItemsValues[
          'rent_listing_date'
        ]
          ? ' Rent Listing Expiry Date *'
          : 'Rent Listing Expiry Date';
      }
    }
  }, [itemValue]);

  useEffect(() => {
    const unitRefNumleadOwnerIndex = allItems.indexOf(
      allItems.find((f) => f.data.DtoName === 'unit_ref_number_owner_lead')
    );
    setIsLeadOwnerForm(unitRefNumleadOwnerIndex !== -1 ? true : false);
  }, []);

  useEffect(() => {
    getIsPropertyLocked();
  }, []);

  useEffect(() => {
    if (window.location.pathname.includes('lead-profile-edit') && propertyId) {
      getIsPropertyLocked(true, propertyId);
    }
  }, [propertyId]);

  useEffect(() => {
    if (allItemsValues?.property_name?.id && !propertyId) {
      setPropertyId(allItemsValues.property_name.id);
    }

    if (
      allItemsValues?.property_name?.id &&
      ['unit_number', 'phase_number', 'building_number'].includes(item.field.id)
    ) {
      getIsPropertyLocked(true, allItemsValues.property_name.id);
    }
  }, [allItemsValues?.property_name]);

  const checkAgentIsBlocked = async (value) => {
    if (value) {
      try {
        const res = await checkIfAgentIsBlocked(value?.id);
        return res;
      } catch {
        showError(t('an-error-blocked-agent'));
      }
    }
  };

  return (
    <>
      {item.field.FieldType === "UnitsModels" && (
        <div className="form-item">
          <div className="d-flex-column w-100">
            <label htmlFor={item.field.id} className="label-wrapper">
              {label}
            </label>
            <div className="chip-input-wrapper">
              <ChipInput
                className="chip-input theme-form-builder"
                InputProps={{ autoComplete: "new-password" }}
                id={item.field.id}
                value={itemValue && itemValue.Models ? itemValue.Models : []}
                onAdd={(chip) => {
                  if (!isNaN(chip)) return;

                  if (
                    itemValue &&
                    itemValue.Models &&
                    itemValue.Models.length > 0
                  ) {
                    Object.keys(itemValue).forEach((key) => {
                      if (
                        typeof itemValue[key] === "object" &&
                        key !== "Models"
                      ) {
                        const isExist = itemValue.Models.findIndex(
                          (modelItem) => modelItem === key
                        );
                        if (isExist === -1) delete itemValue[key];
                      }
                    });
                  } else if (
                    itemValue &&
                    itemValue.Models &&
                    itemValue.Models.length === 0
                  ) {
                    Object.keys(itemValue).forEach((key) => {
                      if (
                        typeof itemValue[key] === "object" &&
                        key !== "Models"
                      )
                        delete itemValue[key];
                    });
                  }
                  if (itemValue && itemValue.Models) {
                    onValueChanged({
                      ...itemValue,
                      Models: [...itemValue.Models, chip],
                    });
                  } else onValueChanged({ Models: [chip] });
                }}
                onDelete={(chip, itemIndex) => {
                  if (itemValue && itemValue.Models)
                    itemValue.Models.splice(itemIndex, 1);
                  delete itemValue[chip];
                  if (
                    itemValue &&
                    itemValue.Models &&
                    itemValue.Models.length > 0
                  ) {
                    Object.keys(itemValue).forEach((key) => {
                      if (
                        typeof itemValue[key] === "object" &&
                        key !== "Models"
                      ) {
                        const isExist = itemValue.Models.findIndex(
                          (modelItem) => modelItem === key
                        );
                        if (isExist === -1) delete itemValue[key];
                      }
                    });
                  } else if (
                    itemValue &&
                    itemValue.Models &&
                    itemValue.Models.length === 0
                  ) {
                    Object.keys(itemValue).forEach((key) => {
                      if (
                        typeof itemValue[key] === "object" &&
                        key !== "Models"
                      )
                        delete itemValue[key];
                    });
                    onValueChanged(null, undefined, "units_models");
                    return;
                  }
                  onValueChanged({ ...itemValue });
                }}
              />
              <Button
                className="ml-2-reversed btns-icon theme-solid bg-blue-lighter"
                disabled={
                  !(
                    itemValue &&
                    itemValue.Models &&
                    itemValue.Models.length > 0
                  )
                }
                onClick={() => {
                  if (
                    itemValue &&
                    itemValue.Models &&
                    itemValue.Models.length > 0
                  )
                    setModelsUnitsDialog(true);
                }}
              >
                <span className="mdi mdi-plus" />
              </Button>
            </div>
          </div>
          {(item?.data?.pendingFieldsHelperInfo?.trim() ||
            item?.data?.HelperInfo?.trim()) && (
            <div className="information-open-file">
              <Tooltip
                size="large"
                title={
                  item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                }
                className={item.data.className ? item.data.className : ""}
              >
                <span className="mdi mdi-information-outline" />
              </Tooltip>
            </div>
          )}
        </div>
      )}
      {((item.field.FieldType === "address" &&
        (item.data.uiType === "text" || item.data.uiType === "map")) ||
        item.field.FieldType === "MapField") && (
        <div className="form-item">
          {!isNewLayout ? (
            <Inputs
              labelClasses={item.field.isRequired ? "c-red" : ""}
              idRef={item.field.id}
              isRequired={item.field.isRequired}
              isDisabled={
                isLoading ||
                item.data.uiType === "map" ||
                item.field.FieldType === "MapField" ||
                item.data.specialKey === "IsDisabled" ||
                item.data.specialKey === "UnitRefNo" ||
                item.data.isReadonly ||
                fieldWithPermissionsToEdit()
              }
              labelValue={label}
              value={
                (itemValue &&
                  ((item.data.uiType === "text" && itemValue.value) ||
                    ((item.data.uiType === "map" ||
                      item.field.FieldType === "MapField") &&
                      `${itemValue.latitude} , ${itemValue.longitude}`) ||
                    "")) ||
                ""
              }
              isSubmitted={isSubmitted}
              isWithError
              helperText={helperText}
              error={error}
              onInputChanged={
                (item.data.uiType === "text" &&
                  ((e) => {
                    if (item.data.isReadonly) return;

                    onValueChanged({
                      value: e.target.value,
                      type: item.data.addressType,
                    });
                  })) ||
                undefined
              }
              buttonOptions={
                ((item.data.uiType === "map" ||
                  item.field.FieldType === "MapField") && {
                  className: "btns-icon theme-outline c-blue-lighter",
                  iconClasses: "mdi mdi-map-marker",
                  isDisabled: item.data.isReadonly || false,
                  isRequired: false,
                  onActionClicked: () => {
                    setOpenMapDialog(true);
                  },
                }) ||
                undefined
              }
            />
          ) : (
            <ReskinningInputs
              fieldClasses={styles.fieldClasses}
              labelClasses={item.field.isRequired ? "c-red" : ""}
              idRef={item.field.id}
              isRequired={item.field.isRequired}
              isDisabled={
                isLoading ||
                item.data.uiType === "map" ||
                item.field.FieldType === "MapField" ||
                item.data.specialKey === "IsDisabled" ||
                item.data.specialKey === "UnitRefNo" ||
                item.data.isReadonly ||
                fieldWithPermissionsToEdit()
              }
              labelValue={label}
              value={
                (itemValue &&
                  ((item.data.uiType === "text" && itemValue.value) ||
                    ((item.data.uiType === "map" ||
                      item.field.FieldType === "MapField") &&
                      `${itemValue.latitude} , ${itemValue.longitude}`) ||
                    "")) ||
                ""
              }
              isSubmitted={isSubmitted}
              isWithError
              helperText={helperText}
              error={error}
              onInputChanged={
                (item.data.uiType === "text" &&
                  ((e) => {
                    if (item.data.isReadonly) return;

                    onValueChanged({
                      value: e.target.value,
                      type: item.data.addressType,
                    });
                  })) ||
                undefined
              }
              helperInfo={
                item?.data?.pendingFieldsHelperInfo ||
                item?.data?.HelperInfo?.trim() ||
                undefined
              }
              Icon={() => {
                return item.data.uiType === "map" ||
                  item.field.FieldType === "MapField" ? (
                  <MapIcon
                    width="20px"
                    height="20px"
                    fill={
                      item.data.isReadonly
                        ? palette.foreground.disabled
                        : palette.button.secondary_fg
                    }
                    onClick={
                      !item.data.isReadonly
                        ? () =>
                            itemValue &&
                            (item.data.uiType === "map" ||
                              item.field.FieldType === "MapField") &&
                            setOpenMapDialog(true)
                        : undefined
                    }
                    style={{
                      marginLeft: "8px",
                      display: "flex",
                      alignSelf: "center",
                      cursor: item.data.isReadonly ? "not-allowed" : "pointer",
                    }}
                  />
                ) : null;
              }}
            />
          )}
          {openMapDialog &&
            isNewLayout &&
            itemValue &&
            (item.data.uiType === "map" ||
              item.field.FieldType === "MapField") && (
              <CustomMapDialog
                open={openMapDialog}
                onChange={(e) => {
                  onValueChanged({ ...e });
                }}
                initialState={itemValue}
                closeDialog={() => {
                  setOpenMapDialog(false);
                }}
              />
            )}
          {(item?.data?.pendingFieldsHelperInfo?.trim() ||
            item?.data?.HelperInfo?.trim()) &&
            !isNewLayout && (
              <div className="information-open-file">
                <Tooltip
                  size="large"
                  title={
                    item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                  }
                  className={item.data.className ? item.data.className : ""}
                >
                  <span className="mdi mdi-information-outline" />
                </Tooltip>
              </div>
            )}
        </div>
      )}
      {((item.field.FieldType === "textField" &&
        item.data.specialKey !== "currency" &&
        item.data.specialKey !== "size" &&
        item.data.specialKey !== "decimal") ||
        item.field.FieldType === "textarea") && (
        <div className="form-item">
          <div className="w-100 p-relative">
            {item.field.id !== "unit_model" &&
              item.field.id !== "closing_remarks" && (
                <>
                  {!isNewLayout ? (
                    <Inputs
                      labelClasses={item.field.isRequired ? "c-red" : ""}
                      idRef={item.field.id}
                      isRequired={item.field.isRequired}
                      isDisabled={
                        isLoading ||
                        (isPropertyLocked &&
                          [
                            "unit_number",
                            "phase_number",
                            "building_number",
                          ].includes(item.field.id) &&
                          item.data.valueToEdit != null &&
                          item.data.valueToEdit !== "") ||
                        getIsUpdateCloseResonAndRemarks() ||
                        customerProfileSelected() ||
                        item.data.isReadonly ||
                        item.data.specialKey === "IsDisabled" ||
                        item.data.specialKey === "UnitRefNo" ||
                        notUpdateInsideForm() ||
                        fieldWithPermissionsToEdit() ||
                        cannotBeModifiedFieldValues()
                      }
                      labelValue={label}
                      value={itemValue || ""}
                      isWithError
                      multiline={item.field.FieldType === "textarea"}
                      isSubmitted={isSubmitted}
                      helperText={helperText}
                      onInputFocus={
                        (item.field.id === "unit_model" &&
                          openUnitModelPopoverHandler) ||
                        undefined
                      }
                      onInputBlur={
                        (item.field.id === "unit_model" && onPopoverClose) ||
                        undefined
                      }
                      error={error}
                      rows={
                        (item.field.FieldType === "textarea" && 4) || undefined
                      }
                      onInputChanged={(e) => {
                        if (item.data.isReadonly) return;

                        onValueChanged(e.target.value);
                      }}
                    />
                  ) : (
                    <ReskinningInputs
                      fieldClasses={styles.fieldClasses}
                      labelClasses={item.field.isRequired ? "c-red" : ""}
                      idRef={item.field.id}
                      isRequired={item.field.isRequired}
                      isDisabled={
                        isLoading ||
                        (isPropertyLocked &&
                          [
                            "unit_number",
                            "phase_number",
                            "building_number",
                          ].includes(item.field.id) &&
                          item.data.valueToEdit != null &&
                          item.data.valueToEdit !== "") ||
                        getIsUpdateCloseResonAndRemarks() ||
                        customerProfileSelected() ||
                        item.data.isReadonly ||
                        item.data.specialKey === "IsDisabled" ||
                        item.data.specialKey === "UnitRefNo" ||
                        notUpdateInsideForm() ||
                        fieldWithPermissionsToEdit() ||
                        cannotBeModifiedFieldValues()
                      }
                      labelValue={label}
                      value={itemValue || ""}
                      isWithError
                      multiline={item.field.FieldType === "textarea"}
                      isSubmitted={isSubmitted}
                      helperText={helperText}
                      onInputFocus={
                        (item.field.id === "unit_model" &&
                          openUnitModelPopoverHandler) ||
                        undefined
                      }
                      onInputBlur={
                        (item.field.id === "unit_model" && onPopoverClose) ||
                        undefined
                      }
                      error={error}
                      rows={
                        (item.field.FieldType === "textarea" && 4) || undefined
                      }
                      onInputChanged={(e) => {
                        if (item.data.isReadonly) return;

                        onValueChanged(e.target.value);
                      }}
                      helperInfo={
                        item?.data?.pendingFieldsHelperInfo ||
                        item.data.HelperInfo ||
                        undefined
                      }
                    />
                  )}
                </>
              )}

            {item.field.id !== "unit_model" &&
              item.field.id === "closing_remarks" &&
              allItemsValues.status &&
              allItemsValues.status.lookupItemName === "Closed" && (
                <>
                  {/* TODO: Reskinning */}
                  <Inputs
                    labelClasses={item.field.isRequired ? "c-red" : ""}
                    idRef={item.field.id}
                    isRequired={item.field.isRequired}
                    isDisabled={
                      isLoading ||
                      getIsUpdateCloseResonAndRemarks() ||
                      item.data.isReadonly ||
                      item.data.specialKey === "IsDisabled" ||
                      item.data.specialKey === "UnitRefNo" ||
                      fieldWithPermissionsToEdit()
                    }
                    labelValue={label}
                    value={itemValue || ""}
                    isWithError
                    multiline={item.field.FieldType === "textarea"}
                    isSubmitted={isSubmitted}
                    helperText={helperText}
                    onInputFocus={
                      (item.field.id === "unit_model" &&
                        openUnitModelPopoverHandler) ||
                      undefined
                    }
                    onInputBlur={
                      (item.field.id === "unit_model" && onPopoverClose) ||
                      undefined
                    }
                    error={error}
                    rows={
                      (item.field.FieldType === "textarea" && 4) || undefined
                    }
                    onInputChanged={(e) => {
                      if (item.data.isReadonly) return;

                      onValueChanged(e.target.value);
                    }}
                  />
                </>
              )}

            {allItemsValues &&
              item.field.id === "unit_model" &&
              item.data.DtoName === "unit_model_unit" && (
                <UnitModelPopoverComponent
                  unitModelPopoverAttachedWith={unitModelPopoverAttachedWith}
                  onPopoverClose={onPopoverClose}
                  item={item}
                  itemValue={itemValue}
                  allItems={allItems}
                  propertyId={
                    allItemsValues.property_name &&
                    allItemsValues.property_name.id
                  }
                  onValueChanged={onValueChanged}
                  labelValue={label}
                  idRef={id}
                  allItemsValues={allItemsValues}
                  propertyName={allItemsValues && allItemsValues.property_name}
                  parentTranslationPath={parentTranslationPath}
                  translationPath={translationPath}
                />
              )}
          </div>
          {(item?.data?.pendingFieldsHelperInfo?.trim() ||
            item?.data?.HelperInfo?.trim()) &&
            !isNewLayout && (
              <div className="information-open-file-2">
                <Tooltip
                  size="large"
                  title={
                    item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                  }
                  className={item.data.className ? item.data.className : ""}
                >
                  <span className="mdi mdi-information-outline" />
                </Tooltip>
              </div>
            )}
        </div>
      )}

      {displyTextField() && (
        <div className="form-item">
          <div className="w-100 p-relative">
            {!isNewLayout ? (
              <Inputs
                isAttachedInput
                key={item.field.id}
                type={item.data.isReadonly ? "text" : "number"}
                endAdornment={
                  item.data.specialKey === "currency" && (
                    <InputAdornment position="start" className="px-2">
                      AED
                    </InputAdornment>
                  )
                }
                labelClasses={item.field.isRequired ? "c-red" : ""}
                idRef={item.field.id}
                isRequired={item.field.isRequired}
                isDisabled={
                  item.data.isReadonly ||
                  id === "amount_due_to_developer" ||
                  id === "pricesqm" ||
                  financialStatusDetailsRules() ||
                  customerProfileSelected() ||
                  isLoading ||
                  fieldWithPermissionsToEdit()
                }
                labelValue={label}
                value={itemValue || ""}
                isWithError
                isSubmitted={isSubmitted}
                helperText={helperText}
                error={error}
                withNumberFormat={!item.data.isReadonly}
                onKeyUp={(e) => {
                  if (item.data.isReadonly) return;
                  const { value } = e.target;
                  if (id === "pricesqm") {
                    const fixed = value && value.replace(/,/g, "");
                    const editValue = fixed ? parseFloat(fixed) : 0;
                    if (editValue) onValueChanged(parseFloat(editValue));
                    else onValueChanged(editValue);
                  }
                  const sellingPrice =
                    allItemsValues && allItemsValues.selling_price_agency_fee;
                  if (id === "builtup_area_sqm") {
                    setTimeout(() => {
                      BuiltupAreaSqmRule(
                        id,
                        value,
                        onValueChanged,
                        2,
                        allItems,
                        sellingPrice
                      );
                    }, 100);
                  } else if (id === "builtup_area_sqft") {
                    setTimeout(() => {
                      BuiltupAreaRule2(
                        id,
                        value,
                        (sellingPrice && sellingPrice.salePrice) || 0,
                        onValueChanged,
                        2,
                        allItems,
                        item
                      );
                    }, 200);
                  }
                }}
                onInputChanged={(e) => {
                  if (item.data.isReadonly) return;
                  if (id !== "pricesqm") {
                    if (id === "builtup_area_sqft") {
                      const sellingPrice =
                        allItemsValues &&
                        allItemsValues.selling_price_agency_fee;
                    }
                    LiabilityAmount2(
                      item,
                      e.target.value,
                      allItems,
                      allItemsValues,
                      onValueChanged
                    );
                    if (id === "builtup_area_sqft")
                      onValueChanged(
                        !Number.isNaN(e.target.value)
                          ? parseFloat(e.target.value)
                          : 0
                      );
                    else if (!Number.isNaN(e.target.value))
                      onValueChanged(parseFloat(e.target.value));
                    else onValueChanged(0);
                  }
                }}
              />
            ) : (
              <ReskinningInputs
                fieldClasses={styles.fieldClasses}
                isAttachedInput
                key={item.field.id}
                type={item.data.isReadonly ? "text" : "number"}
                endAdornment={
                  item.data.specialKey === "currency" && (
                    <InputAdornment position="start" className="px-2">
                      AED
                    </InputAdornment>
                  )
                }
                labelClasses={item.field.isRequired ? "c-red" : ""}
                idRef={item.field.id}
                isRequired={item.field.isRequired}
                isDisabled={
                  item.data.isReadonly ||
                  id === "amount_due_to_developer" ||
                  id === "pricesqm" ||
                  financialStatusDetailsRules() ||
                  customerProfileSelected() ||
                  isLoading ||
                  fieldWithPermissionsToEdit()
                }
                labelValue={label}
                value={itemValue || ""}
                isWithError
                isSubmitted={isSubmitted}
                helperText={helperText}
                error={error}
                withNumberFormat={!item.data.isReadonly}
                onKeyUp={(e) => {
                  if (item.data.isReadonly) return;
                  const { value } = e.target;
                  if (id === "pricesqm") {
                    const fixed = value && value.replace(/,/g, "");
                    const editValue = fixed ? parseFloat(fixed) : 0;
                    if (editValue) onValueChanged(parseFloat(editValue));
                    else onValueChanged(editValue);
                  }
                  const sellingPrice =
                    allItemsValues && allItemsValues.selling_price_agency_fee;
                  if (id === "builtup_area_sqm") {
                    setTimeout(() => {
                      BuiltupAreaSqmRule(
                        id,
                        value,
                        onValueChanged,
                        2,
                        allItems,
                        sellingPrice
                      );
                    }, 100);
                  } else if (id === "builtup_area_sqft") {
                    setTimeout(() => {
                      BuiltupAreaRule2(
                        id,
                        value,
                        (sellingPrice && sellingPrice.salePrice) || 0,
                        onValueChanged,
                        2,
                        allItems,
                        item
                      );
                    }, 200);
                  }
                }}
                onInputChanged={(e) => {
                  if (item.data.isReadonly) return;
                  if (id !== "pricesqm") {
                    if (id === "builtup_area_sqft") {
                      const sellingPrice =
                        allItemsValues &&
                        allItemsValues.selling_price_agency_fee;
                    }
                    LiabilityAmount2(
                      item,
                      e.target.value,
                      allItems,
                      allItemsValues,
                      onValueChanged
                    );
                    if (id === "builtup_area_sqft")
                      onValueChanged(
                        !Number.isNaN(e.target.value)
                          ? parseFloat(e.target.value)
                          : 0
                      );
                    else if (!Number.isNaN(e.target.value))
                      onValueChanged(parseFloat(e.target.value));
                    else onValueChanged(0);
                  }
                }}
                helperInfo={
                  item?.data?.pendingFieldsHelperInfo ||
                  item?.data?.HelperInfo?.trim() ||
                  undefined
                }
              />
            )}
          </div>
          {(item?.data?.pendingFieldsHelperInfo?.trim() ||
            item?.data?.HelperInfo?.trim()) &&
            !isNewLayout && (
              <div className="information-open-file-2">
                <Tooltip
                  size="large"
                  title={
                    item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                  }
                  className={item.data.className ? item.data.className : ""}
                >
                  <span className="mdi mdi-information-outline" />
                </Tooltip>
              </div>
            )}
        </div>
      )}

      {item.field.FieldType === "communication" &&
        ((!isNewLayout && item.data.CommunicationType === "Email") ||
          item.data.CommunicationType === "SocialMedia") && (
          <div className="form-item">
            {!isNewLayout ? (
              <Inputs
                labelClasses={item.field.isRequired ? "c-red" : ""}
                idRef={item.field.id}
                isRequired={item.field.isRequired}
                isDisabled={
                  isLoading ||
                  item.data.isReadonly ||
                  item.data.specialKey === "IsDisabled" ||
                  item.data.specialKey === "UnitRefNo" ||
                  fieldWithPermissionsToEdit()
                }
                labelValue={label}
                value={
                  (itemValue &&
                    ((item.data.CommunicationType === "Email" &&
                      itemValue.email) ||
                      itemValue.link ||
                      "")) ||
                  ""
                }
                isWithError
                isSubmitted={isSubmitted}
                helperText={helperText}
                error={error}
                onInputChanged={(e) => {
                  if (item.data.isReadonly) return;
                  if (item.data.CommunicationType === "Email") {
                    if (e.target.value === "") {
                      onValueChanged(null);
                      return;
                    }
                    onValueChanged({
                      email: e.target.value.toLowerCase(),
                      typeId: item.data.lookupItem,
                    });
                  } else {
                    onValueChanged({
                      link: e.target.value,
                      typeId: item.data.lookupItem,
                    });
                  }
                }}
                buttonOptions={
                  (item.data.CommunicationType === "Email" && {
                    className: "btns-icon theme-solid bg-blue-lighter",
                    iconClasses: "mdi mdi-plus",
                    isDisabled:
                      item.data.isReadonly ||
                      !(
                        itemValue &&
                        new RegExp(item.data.regExp).test(itemValue.email) &&
                        itemValue.email &&
                        itemValue.email.length > 0
                      ) ||
                      fieldWithPermissionsToEdit(),
                    isRequired: false,
                    onActionClicked: () => {
                      if (
                        itemValue &&
                        new RegExp(item.data.regExp).test(itemValue.email) &&
                        itemValue.email &&
                        itemValue.email.length > 0
                      )
                        setRepeatedDialog(true);
                    },
                  }) ||
                  undefined
                }
              />
            ) : (
              <ReskinningInputs
                fieldClasses={styles.fieldClasses}
                labelClasses={item.field.isRequired ? "c-red" : ""}
                idRef={item.field.id}
                isRequired={item.field.isRequired}
                isDisabled={
                  isLoading ||
                  item.data.isReadonly ||
                  item.data.specialKey === "IsDisabled" ||
                  item.data.specialKey === "UnitRefNo" ||
                  fieldWithPermissionsToEdit()
                }
                labelValue={label}
                value={
                  (itemValue &&
                    ((item.data.CommunicationType === "Email" &&
                      itemValue.email) ||
                      itemValue.link ||
                      "")) ||
                  ""
                }
                isWithError
                isSubmitted={isSubmitted}
                helperText={helperText}
                error={error}
                onInputChanged={(e) => {
                  if (item.data.isReadonly) return;
                  if (item.data.CommunicationType === "Email") {
                    if (e.target.value === "") {
                      onValueChanged(null);
                      return;
                    }
                    onValueChanged({
                      email: e.target.value.toLowerCase(),
                      typeId: item.data.lookupItem,
                    });
                  } else {
                    onValueChanged({
                      link: e.target.value,
                      typeId: item.data.lookupItem,
                    });
                  }
                }}
                buttonOptions={
                  (item.data.CommunicationType === "Email" && {
                    className: "btns-icon theme-solid bg-blue-lighter",
                    iconClasses: "mdi mdi-plus",
                    isDisabled:
                      item.data.isReadonly ||
                      !(
                        itemValue &&
                        new RegExp(item.data.regExp).test(itemValue.email) &&
                        itemValue.email &&
                        itemValue.email.length > 0
                      ) ||
                      fieldWithPermissionsToEdit(),
                    isRequired: false,
                    onActionClicked: () => {
                      if (
                        itemValue &&
                        new RegExp(item.data.regExp).test(itemValue.email) &&
                        itemValue.email &&
                        itemValue.email.length > 0
                      )
                        setRepeatedDialog(true);
                    },
                  }) ||
                  undefined
                }
                helperInfo={
                  item?.data?.pendingFieldsHelperInfo ||
                  item.data.HelperInfo ||
                  undefined
                }
              />
            )}
            {(item?.data?.pendingFieldsHelperInfo?.trim() ||
              item?.data?.HelperInfo?.trim()) &&
              !isNewLayout && (
                <div className="information-open-file-2">
                  <Tooltip
                    size="large"
                    title={
                      item?.data?.pendingFieldsHelperInfo ||
                      item.data.HelperInfo
                    }
                    className={item.data.className ? item.data.className : ""}
                  >
                    <span className="mdi mdi-information-outline" />
                  </Tooltip>
                </div>
              )}
          </div>
        )}

      {item.data.CommunicationType === "Email" && isNewLayout && (
        <Box className="form-item">
          <FBFieldWrapper
            label={label}
            required={item.field.isRequired}
            helperInfo={emailError ? "" : helperText}
            labelPosition={"side"}
          >
            <Box
              className={clsx("additional-table", styles.fieldClasses)}
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              {!isAdding ? (
                <EmailInput
                  fieldClasses={styles.fieldClasses}
                  idRef={id}
                  isRequired={item.field.isRequired}
                  value={itemValue?.email}
                  isDisabled={true}
                  labelValue={label}
                  error={emailError}
                  errorMessage={emailError}
                  onInputChanged={(e) => {
                    if (item.data.isReadonly) return;
                    if (item.data.CommunicationType === "Email") {
                      if (e.target.value === "") {
                        onValueChanged(null);
                        return;
                      }
                      onValueChanged({
                        email: e.target.value.toLowerCase(),
                        typeId: item.data.lookupItem,
                      });
                    } else {
                      onValueChanged({
                        link: e.target.value,
                        typeId: item.data.lookupItem,
                      });
                    }
                  }}
                  setNewValue={setNewValue}
                  isAdding={isAdding}
                  setIsAdding={setIsAdding}
                  allowOthers={true}
                />
              ) : (
                <EmailInput
                  fieldClasses={styles.fieldClasses}
                  idRef={id}
                  isRequired={item.field.isRequired}
                  value={
                    (itemValue &&
                      ((item.data.CommunicationType === "Email" &&
                        itemValue.email) ||
                        itemValue.link ||
                        "")) ||
                    ""
                  }
                  isDisabled={false}
                  labelValue={label}
                  error={emailError}
                  errorMessage={emailError}
                  onInputChanged={(e) => {
                    if (item.data.isReadonly) return;
                    if (item.data.CommunicationType === "Email") {
                      if (e.target.value === "") {
                        onValueChanged(null);
                        return;
                      }
                      onValueChanged({
                        email: e.target.value.toLowerCase(),
                        typeId: item.data.lookupItem,
                      });
                    } else {
                      onValueChanged({
                        link: e.target.value,
                        typeId: item.data.lookupItem,
                      });
                    }
                  }}
                  setNewValue={setNewValue}
                  isAdding={isAdding}
                  setIsAdding={setIsAdding}
                  allowOthers={true}
                />
              )}

              {(isAdding || newValue?.others?.length > 0) && (
                <AddAdditionalTable
                  initValue={newValue?.email}
                  others={newValue?.others || []}
                  setNewValue={setNewValue}
                  columnName="email"
                  setData={() => {}}
                  item={item}
                  newValue={newValue}
                  index={""}
                  isRequired={item.field.isRequired}
                  setIsAdding={setIsAdding}
                />
              )}
            </Box>
          </FBFieldWrapper>
        </Box>
      )}

      {item.field.FieldType === "rangeField" && (
        <div className="form-item flex-wrap px-0">
          <div className="w-50 px-2">
            {/* TODO: Reskinning */}
            <Inputs
              idRef={item.field.id}
              labelClasses={item.field.isRequired ? "c-red" : ""}
              labelValue={label}
              inputPlaceholder={t("from")}
              value={itemValue ? itemValue[0] : Number(item.data.minNumber)}
              isRequired={item.field.isRequired}
              helperText={helperText}
              withNumberFormat
              error={error}
              isDisabled={fieldWithPermissionsToEdit()}
              isWithError
              isSubmitted={isSubmitted}
              onInputChanged={(e) => {
                if (item.data.isReadonly) return;
                if (e.target.value === "" || /^\d+$/.test(e.target.value)) {
                  const v = itemValue || [];
                  if (e.target.value === "") {
                    v[0] = parseFloat(Number(item.data.minNumber));
                    onValueChanged(v);
                    return;
                  }
                  const withoutCommaInNumber = parseFloat(
                    e.target.value && e.target.value.replace(/,/g, "")
                  );

                  if (
                    v &&
                    v[0] &&
                    withoutCommaInNumber &&
                    v &&
                    v.length === 2 &&
                    v[1] &&
                    withoutCommaInNumber > Number(v[1])
                  )
                    v[0] = itemValue && itemValue[0];
                  else v[0] = parseFloat(e.target.value);

                  onValueChanged(v);
                }
              }}
              onInputBlur={(e) => {
                if (item.data.isReadonly) return;
                const sizeValue = e.target.value;
                const withoutCommaInNumber = parseFloat(
                  sizeValue && sizeValue.replace(/,/g, "")
                );

                const v = itemValue || [];
                if (
                  withoutCommaInNumber &&
                  v &&
                  v.length === 2 &&
                  v[1] &&
                  withoutCommaInNumber > Number(v[1])
                )
                  return;

                if (withoutCommaInNumber < Number(item.data.minNumber)) {
                  v[0] = Number(item.data.minNumber);
                  onValueChanged(v);
                } else if (
                  Number(withoutCommaInNumber) > Number(item.data.maxNumber)
                ) {
                  v[0] = Number(item.data.maxNumber);
                  onValueChanged(v);
                } else {
                  v[0] = withoutCommaInNumber;
                  onValueChanged(v);
                }
                if (item.field.id === "size_sqft")
                  LeadConvertSizeSqftToSqmRule2(
                    item,
                    v[0],
                    allItemsValues,
                    onValueChanged,
                    "from",
                    allItems
                  );
                else if (item.field.id === "size_sqm")
                  LeadConvertSizeSqmToSqftRule2(
                    item,
                    v[0],
                    allItemsValues,
                    onValueChanged,
                    "from",
                    allItems
                  );
              }}
            />
          </div>
          <div className="w-50 px-2">
            {/* TODO: Reskinning */}
            <Inputs
              idRef={`${item.field.id}to`}
              labelValue={t("to")}
              value={
                itemValue
                  ? (itemValue && itemValue[1]) || Number(item.data.maxNumber)
                  : Number(item.data.maxNumber)
              }
              isRequired={item.field.isRequired}
              isDisabled={fieldWithPermissionsToEdit()}
              labelClasses={item.field.isRequired ? "c-red" : ""}
              helperText={helperText}
              error={error}
              isWithError
              withNumberFormat
              isSubmitted={isSubmitted}
              onInputChanged={(e) => {
                if (item.data.isReadonly) return;
                if (e.target.value === "" || /^\d+$/.test(e.target.value)) {
                  const v = itemValue || [];
                  if (e.target.value === "") {
                    v[1] = parseFloat(Number(item.data.maxNumber));
                    onValueChanged(v);
                    return;
                  }
                  const withoutCommaInNumber = parseFloat(
                    e.target.value && e.target.value.replace(/,/g, "")
                  );

                  v[1] = parseFloat(withoutCommaInNumber);

                  onValueChanged(v);
                }
              }}
              onInputBlur={(e) => {
                if (item.data.isReadonly) return;
                const sizeValue = e.target.value;
                const v = itemValue || [];
                const withoutCommaInNumber = parseFloat(
                  sizeValue && sizeValue.replace(/,/g, "")
                );

                const marks = [
                  {
                    value: parseFloat(item.data.minNumber),
                    label: `${item.data.minNumber}`,
                  },
                  {
                    value: parseFloat(item.data.maxNumber),
                    label: `${item.data.maxNumber}`,
                  },
                ];

                if (withoutCommaInNumber < Number(item.data.minNumber)) {
                  v[1] = Number(marks[1].value);

                  onValueChanged(v);
                } else if (withoutCommaInNumber > Number(item.data.maxNumber)) {
                  v[1] = Number(item.data.maxNumber);
                  onValueChanged(v);
                } else {
                  v[1] = withoutCommaInNumber;
                  onValueChanged(v);
                }

                if (item.field.id === "size_sqft")
                  LeadConvertSizeSqftToSqmRule2(
                    item,
                    v[1],
                    allItemsValues,
                    onValueChanged,
                    "to",
                    allItems
                  );
                else if (item.field.id === "size_sqm")
                  LeadConvertSizeSqmToSqftRule2(
                    item,
                    v[1],
                    allItemsValues,
                    onValueChanged,
                    "to",
                    allItems
                  );
              }}
            />
          </div>

          <div className="helper_rangField px-4">
            <Slider
              required={item.field.isRequired}
              className="sliders"
              aria-labelledby="range-slider"
              valueLabelDisplay="auto"
              onChange={(event, value) => {
                if (item.data.isReadonly) return;
                if (item.field.id === "size_sqft")
                  LeadConvertSizeSqftToSqmRuleSlider(value, onValueChanged);
                else if (item.field.id === "size_sqm")
                  LeadConvertSizeSqmToSqftRuleSlider(value, onValueChanged);

                if (
                  !itemValue ||
                  value[0] !== itemValue[0] ||
                  value[1] !== (itemValue && itemValue[1])
                )
                  onValueChanged(value);
              }}
              value={
                itemValue && Array.isArray(itemValue) && itemValue.length > 0
                  ? [
                      typeof itemValue[0] === "number" ||
                      typeof itemValue[0] === "string"
                        ? parseFloat(itemValue[0].toFixed(2))
                        : item.data.minNumber,
                      itemValue &&
                      itemValue[1] &&
                      typeof itemValue[1] === "number"
                        ? parseFloat(itemValue[1].toFixed(2)) ||
                          item.data?.maxNumber
                        : item.data?.maxNumber,
                    ]
                  : [
                      item.data?.minNumber ? item.data.minNumber : null,
                      item.data?.maxNumber ? item.data.maxNumber : null,
                    ]
              }
              step={item.field.id === "size_sqft" ? 200 : 20}
              marks={[
                {
                  value: parseFloat(item.data.minNumber),
                  label: `${parseFloat(item.data.minNumber)}`,
                },
                {
                  value: item.data.maxNumber,
                  label: `${parseFloat(item.data.maxNumber)}`,
                },
              ]}
              min={Number(item.data.minNumber)}
              max={Number(item.data.maxNumber)}
            />
            {(item?.data?.pendingFieldsHelperInfo?.trim() ||
              item?.data?.HelperInfo?.trim()) && (
              <Tooltip
                size="large"
                title={
                  item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                }
                className={item.data.className ? item.data.className : ""}
              >
                <span className="mdi mdi-information-outline" />
              </Tooltip>
            )}
          </div>
        </div>
      )}

      {(item.data.CommunicationType === "Phone" ||
        item.field.FieldType === "phone") &&
        !isNewLayout && (
          <div className="form-item">
            <PhonesComponent
              labelClasses={item.field.isRequired ? "c-red" : ""}
              idRef={item.field.id}
              labelValue={label}
              required={item.field.isRequired}
              value={
                itemValue === null ||
                itemValue === undefined ||
                !itemValue.phone
                  ? item.data.defaultCountryCode
                  : itemValue.phone
              }
              onInputChanged={(value) => {
                if (item.data.isReadonly) return;
                onValueChanged(
                  value !== ""
                    ? { phone: value, typeId: item.data.lookupItem }
                    : null
                );
              }}
              isDisabled={
                item.data.isReadonly ||
                isLoading ||
                fieldWithPermissionsToEdit()
              }
              isSubmitted={isSubmitted}
              error={error}
              helperText={helperText}
              buttonOptions={{
                className: "btns-icon theme-solid bg-blue-lighter",
                iconClasses: "mdi mdi-plus",
                isDisabled:
                  item.data.isReadonly ||
                  !(
                    itemValue &&
                    itemValue.phone &&
                    itemValue.phone.length >= 9
                  ) ||
                  fieldWithPermissionsToEdit(),
                isRequired: false,
                onActionClicked: () => {
                  if (
                    itemValue &&
                    itemValue.phone &&
                    itemValue.phone.length >= 9
                  )
                    setRepeatedDialog(true);
                },
              }}
            />
            {(item?.data?.pendingFieldsHelperInfo?.trim() ||
              item?.data?.HelperInfo?.trim()) && (
              <div className="information-open-file-2">
                <Tooltip
                  size="large"
                  title={
                    item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                  }
                  className={item.data.className ? item.data.className : ""}
                >
                  <span className="mdi mdi-information-outline" />
                </Tooltip>
              </div>
            )}
          </div>
        )}

      {isNewLayout &&
        (item.data.CommunicationType === "Phone" ||
          item.field.FieldType === "phone") && (
          <Box className="form-item">
            <FBFieldWrapper
              label={label}
              required={item.field.isRequired}
              helperInfo={phoneError ? "" : helperText}
              labelPosition={"side"}
            >
              <Box
                className={clsx("additional-table", styles.fieldClasses)}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                {!isAdding && item.field.isRequired ? (
                  <PhoneNumberInput
                    fieldClasses={styles.fieldClasses}
                    required={item.field.isRequired}
                    name="phoneRef"
                    idRef={item.field.id}
                    inputPlaceholder="+1 (555) 000-0000"
                    value={
                      itemValue === null ||
                      itemValue === undefined ||
                      !itemValue.phone
                        ? item.data.defaultCountryCode
                        : itemValue.phone
                    }
                    isDisabled={true}
                    country={country}
                    onInputChanged={(value) => {}}
                    error={phoneError}
                    onKeyUp={() => {}}
                    onKeyDown={() => {}}
                    setNewValue={setNewValue}
                    isAdding={isAdding}
                    setIsAdding={setIsAdding}
                    allowOthers={true}
                  />
                ) : (
                  <PhoneNumberInput
                    fieldClasses={styles.fieldClasses}
                    required={item.field.isRequired}
                    name="phoneRef"
                    idRef={item.field.id}
                    inputPlaceholder="+1 (555) 000-0000"
                    value={
                      itemValue === null ||
                      itemValue === undefined ||
                      !itemValue.phone
                        ? item.data.defaultCountryCode
                        : itemValue.phone
                    }
                    isDisabled={false}
                    country={country}
                    onInputChanged={(value) => {}}
                    error={phoneError}
                    onKeyUp={(val) => {}}
                    onKeyDown={() => {}}
                    setNewValue={setNewValue}
                    isAdding={isAdding}
                    setIsAdding={setIsAdding}
                    allowOthers={true}
                  />
                )}

                {(isAdding || newValue?.others?.length > 0) && (
                  <AddAdditionalTable
                    initValue={newValue?.phone}
                    others={newValue?.others || []}
                    setNewValue={setNewValue}
                    columnName="Phone number"
                    setData={() => {}}
                    item={item}
                    newValue={newValue}
                    index={""}
                    isRequired={item.field.isRequired}
                    setIsAdding={setIsAdding}
                  />
                )}
              </Box>
            </FBFieldWrapper>
          </Box>
        )}

      {item.field.FieldType === "radio" && (
        <div className="form-item">
          <RadiosGroupComponent
            data={item.data.enum}
            idRef={item.field.id}
            onSelectedRadioChanged={(e) => onValueChanged(e.target.value)}
            value={itemValue}
          />
          {(item?.data?.pendingFieldsHelperInfo?.trim() ||
            item?.data?.HelperInfo?.trim()) && (
            <div className="information-open-file-2">
              <Tooltip
                size="large"
                title={
                  item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                }
                className={item.data.className ? item.data.className : ""}
              >
                <span className="mdi mdi-information-outline" />
              </Tooltip>
            </div>
          )}
        </div>
      )}

      {(item.field.FieldType === "checkbox" ||
        item.field.FieldType === "checkboxes") && (
        <div className="form-item">
          <CheckboxesComponent
            onSelectedCheckboxChanged={(e) => {
              if (item.field.FieldType === "checkboxes") {
                const result = (itemValue && [...itemValue]) || [];
                if (
                  e?.target?.checked &&
                  result.indexOf(e?.target?.value) === -1
                )
                  result.push(e?.target?.value);
                else result.splice(result.indexOf(e?.target?.value), 1);
                onValueChanged(result);
              } else onValueChanged(e?.target?.checked);
            }}
            isRow
            idRef={item.field.id}
            labelClasses={item.field.isRequired ? "c-red" : ""}
            labelValue={label}
            required={item.field.isRequired}
            checked={(selectedItem) =>
              itemValue && [...itemValue].indexOf(selectedItem) !== -1
            }
            value={
              (item.field.FieldType === "checkbox" && itemValue) || undefined
            }
          />
          {(item?.data?.pendingFieldsHelperInfo?.trim() ||
            item?.data?.HelperInfo?.trim()) && (
            <div className="information-open-file-2">
              <Tooltip
                size="large"
                title={
                  item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                }
                className={item.data.className ? item.data.className : ""}
              >
                <span className="mdi mdi-information-outline" />
              </Tooltip>
            </div>
          )}
        </div>
      )}

      {item.field.FieldType === "alt-date" && (
        <div className="form-item">
          {!isNewLayout ? (
            <DatePickerComponent
              required={item.field.isRequired}
              idRef={item.field.id}
              labelValue={label}
              isDisabled={
                customerProfileSelected() ||
                item.data.isReadonly ||
                isLoading ||
                disableListingExpiryPeriod() ||
                listingExpiryDateSelected()
              }
              labelClasses={item.field.isRequired ? "c-red" : ""}
              value={itemValue || null}
              helperText={helperText}
              error={error}
              isSubmitted={isSubmitted}
              maxDate={
                item.data.maxDate &&
                moment(new Date(item.data.maxDate)).isValid()
                  ? moment(new Date(item.data.maxDate))
                  : item.field.id === "listing_date" ||
                    item.field.id === "rent_listing_date"
                  ? ListingAndRentListingDateRule(item, allItems)
                  : undefined
              }
              minDate={
                item.data.minDate &&
                moment(new Date(item.data.minDate)).isValid()
                  ? moment(new Date(item.data.minDate))
                  : undefined
              }
              onDateChanged={(e) => {
                if (item.data.isReadonly) return;
                const newDate = e || null;
                VisaRules(newDate, item, onValueChanged, allItems);

                PassportRule2(id, item, allItems, newDate, onValueChanged);
                ListingDate(id, allItems, newDate);
                ListingExpiryDateRule2(item, onValueChanged);
                ConstructionDateRule(
                  id,
                  item,
                  allItems,
                  newDate,
                  onValueChanged,
                  2
                );
                if (item.field.id === "completion_date") {
                  CompletionDateRule(
                    item.field.id,
                    allItems,
                    newDate,
                    onValueChanged,
                    2
                  );
                }
                if (id === "listing_date" || id === "rent_listing_date")
                  ListingDateRule2(
                    item,
                    newDate,
                    onValueChanged,
                    allItems,
                    allItemsValues
                  );
                if (id === "trade_license_expiry_date") {
                  if (
                    newDate &&
                    id === "trade_license_expiry_date" &&
                    allItemsValues?.trade_license_issue_date
                  ) {
                    if (
                      new Date(newDate) <
                      new Date(allItemsValues?.trade_license_issue_date)
                    ) {
                      showWarn(
                        "Please select date after trade license issue date "
                      );
                    }
                  }
                }
                if (id === "trade_license_issue_date")
                  TradeLicenseDateRule(
                    item,
                    onValueChanged,
                    newDate,
                    allItemsValues,
                    allItems
                  );

                if (moment(newDate).isValid()) {
                  const formattedDate = moment(newDate).format("YYYY/MM/DD");

                  return onValueChanged(formattedDate);
                }

                onValueChanged(newDate && moment(newDate).format("YYYY/MM/DD"));
              }}
            />
          ) : (
            <ReskinningDatePicker
              fieldClasses={styles.fieldClasses}
              required={item.field.isRequired}
              idRef={item.field.id}
              labelValue={label}
              isDisabled={
                customerProfileSelected() ||
                item.data.isReadonly ||
                isLoading ||
                disableListingExpiryPeriod() ||
                listingExpiryDateSelected()
              }
              labelClasses={item.field.isRequired ? "c-red" : ""}
              value={itemValue || null}
              helperText={helperText}
              error={error}
              isSubmitted={isSubmitted}
              maxDate={
                item.data.maxDate &&
                moment(new Date(item.data.maxDate)).isValid()
                  ? moment(new Date(item.data.maxDate))
                  : item.field.id === "listing_date" ||
                    item.field.id === "rent_listing_date"
                  ? ListingAndRentListingDateRule(item, allItems)
                  : undefined
              }
              minDate={
                item.data.minDate &&
                moment(new Date(item.data.minDate)).isValid()
                  ? moment(new Date(item.data.minDate))
                  : undefined
              }
              onDateChanged={(e) => {
                if (item.data.isReadonly) return;
                const newDate = e || "";
                VisaRules(newDate, item, onValueChanged, allItems);

                PassportRule2(id, item, allItems, newDate, onValueChanged);
                ListingDate(id, allItems, newDate);
                ListingExpiryDateRule2(item, onValueChanged);
                ConstructionDateRule(
                  id,
                  item,
                  allItems,
                  newDate,
                  onValueChanged,
                  2
                );
                if (item.field.id === "completion_date") {
                  CompletionDateRule(
                    item.field.id,
                    allItems,
                    newDate,
                    onValueChanged,
                    2
                  );
                }
                if (id === "listing_date" || id === "rent_listing_date")
                  ListingDateRule2(
                    item,
                    newDate,
                    onValueChanged,
                    allItems,
                    allItemsValues
                  );
                if (id === "trade_license_expiry_date") {
                  if (
                    newDate &&
                    id === "trade_license_expiry_date" &&
                    allItemsValues?.trade_license_issue_date
                  ) {
                    if (
                      new Date(newDate) <
                      new Date(allItemsValues?.trade_license_issue_date)
                    ) {
                      showWarn(
                        "Please select date after trade license issue date "
                      );
                    }
                  }
                }
                if (id === "trade_license_issue_date")
                  TradeLicenseDateRule(
                    item,
                    onValueChanged,
                    newDate,
                    allItemsValues,
                    allItems
                  );

                if (moment(newDate).isValid()) {
                  const formattedDate = moment(newDate).format("YYYY/MM/DD");

                  return onValueChanged(formattedDate);
                }
                onValueChanged(newDate);
              }}
              helperInfo={
                item?.data?.pendingFieldsHelperInfo || item?.data?.HelperInfo
              }
            />
          )}
          {(item?.data?.pendingFieldsHelperInfo?.trim() ||
            item?.data?.HelperInfo?.trim()) &&
            !isNewLayout && (
              <div className="information-open-file-2">
                <Tooltip
                  size="large"
                  title={
                    item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                  }
                  className={item.data.className ? item.data.className : ""}
                >
                  <span className="mdi mdi-information-outline" />
                </Tooltip>
              </div>
            )}
        </div>
      )}

      {displySearchFields() &&
        (item.data.uiType === "select" ||
          item.field.FieldType === "UploadFiles" ||
          (item.field.FieldType === "searchField" &&
            item.data.searchKey === "User" &&
            UserDefaultRule(
              item,
              onItemChanged,
              allItems,
              allItemsValues,
              GetParams("activeFormType")
            )) ||
          (item.data.searchKey === "Leads" &&
            LeadsDefaultRule(item, onItemChanged, typeOf, loginResponse)) ||
          (item.field.FieldType === "searchField" &&
            item.field.id !== "owner") ||
          (item.field.FieldType === "select" &&
            item.field.id !== "close_reason" &&
            !(
              item.field.id === "sale_type" &&
              item.data.specialKey === "sale_type_lead_owner"
            ))) && (
          <div className="form-item">
            {!isNewLayout ? (
              <AutocompleteComponent
                labelClasses={item.field.isRequired ? "c-red" : ""}
                idRef={item.field.id}
                isRequired={item.field.isRequired}
                isDisabled={
                  fieldWithPermissionsToEdit() ||
                  getStatusValue() ||
                  disableQualification() ||
                  getLeadOperationValue() ||
                  disableUnitRefNumber() ||
                  disableIsMortgageInTenant() ||
                  customerProfileSelected() ||
                  disableLead() ||
                  isLoading ||
                  item.data.isReadonly ||
                  item.data.specialKey === "IsDisabled" ||
                  item.data.specialKey === "UnitRefNo" ||
                  getSendLeadToRotationSelected() ||
                  getIsLeadAuditor() ||
                  disableContactRate() ||
                  disableRatingLead() ||
                  disableOperationType() ||
                  disableChangePropertyAge() ||
                  disableListingExpiryPeriod() ||
                  getSmartAssignmentSelected() ||
                  disableUnitNumberOfPayments() || 
                  disableName()
                }
                isLoading={isLoading}
                withLoader
                isWithError
                isSubmitted={isSubmitted}
                helperText={helperText}
                error={error}
                multiple={
                  (item.data.multi && item.data.multi === "true") || false
                }
                filterOptions={
                  ((item.data.searchKey === "property" ||
                    item.data.searchKey === "contact" ||
                    item.data.searchKey === "Leads" ||
                    item.data.searchKey === "PropertyOrUnit" ||
                    item.data.searchKey === "developers") &&
                    ((option) => option)) ||
                  undefined
                }
                renderOption={
                  (item.data.searchKey === "property" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate fz-14px">
                          {option.name || ""}
                          <span className="fz-12px">{`${
                            option.property_plan
                              ? ` - ${option.property_plan}`
                              : ""
                          }`}</span>
                        </div>
                        <span className="c-gray-secondary fz-12px">
                          {`${option?.community?.lookupItemName || "N/A"} ${
                            option.subCommunity?.lookupItemName
                              ? `, ${option.subCommunity.lookupItemName}`
                              : ""
                          }`}
                        </span>
                      </div>
                    ))) ||
                  (item.data.searchKey === "User" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate">
                          {(option && option.name) ||
                            (option && option.fullName)}
                        </div>
                        <span className="c-gray-secondary">
                          {option.branch || ""}
                        </span>
                      </div>
                    ))) ||
                  (item.data.searchKey === "contact" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate">
                          {option.name}
                        </div>
                        <span className="c-gray-secondary">{option.phone}</span>
                      </div>
                    ))) ||
                  (item.data.searchKey === "Leads" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate">
                          {option.name}
                        </div>
                        <span className="c-gray-secondary">
                          {option.leadClass}
                        </span>
                      </div>
                    ))) ||
                  (item.data.searchKey === "campaign_name" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate">
                          {option.name}
                        </div>
                      </div>
                    ))) ||
                  (item.data.searchKey === "PropertyOrUnit" &&
                    ((option) =>
                      (option.isProperty && (
                        <span>{`${option.name || ""} - ${
                          option.city || ""
                        }`}</span>
                      )) || (
                        <div className="d-flex-column">
                          <span>{`${option.unitModel} - ${option.name} - ${option.unitType}`}</span>
                          <span className="c-gray-secondary">
                            {`${option.unitBedrooms} - ${option.unitRefNo}`}
                          </span>
                        </div>
                      ))) ||
                  undefined
                }
                selectedValues={
                  item.data.multi && item.data.multi === "true"
                    ? (itemValue &&
                        item.field.FieldType === "UploadFiles" &&
                        itemValue &&
                        itemValue.selected &&
                        itemValue.selected.length > 0 && [
                          ...itemValue.selected,
                        ]) ||
                      (!itemValue && []) ||
                      (itemValue && Array.isArray(itemValue)
                        ? itemValue || []
                        : valueIsObjectBefore || []) ||
                      []
                    : itemValue || null
                }
                data={getDataEnumList(item)}
                chipsLabel={
                  (item.data &&
                    item.data.multi &&
                    item.data.multi === "true" &&
                    ((item.field.FieldType === "searchField" &&
                      ((option) => (option && option.name) || "")) ||
                      ((option) =>
                        !item.data.lookup
                          ? option
                          : (option && option.lookupItemName) || undefined))) ||
                  undefined
                }
                onInputChange={
                  (item.field.FieldType === "searchField" &&
                    ((e, v) => {
                      ContactRule(item, v, onItemChanged);
                      DeveloperContactRule(item, v, onItemChanged);
                      PropertyRule(item, v, onItemChanged);
                      UserRule(
                        item,
                        v,
                        onItemChanged,
                        allItems,
                        allItemsValues,
                        GetParams("activeFormType"),
                        2,
                        onvolumechange
                      );
                      LeadsRule(item, v, onItemChanged, typeOf, loginResponse);
                      PropertyOrUnitRule(
                        item,
                        v,
                        onItemChanged,
                        allItems,
                        allItemsValues
                      );
                      UnitRule(
                        item,
                        v,
                        onItemChanged,
                        allItems,
                        allItemsValues
                      );
                      CampaignsRule(item, v, onItemChanged);
                      BranchLocationRule(item, v, onItemChanged);
                    })) ||
                  undefined
                }
                inputClasses="inputs theme-form-builder"
                displayLabel={
                  (item.field.FieldType === "searchField" &&
                    ((option) =>
                      (option && `${option.name} ${option.barnch || ""}`) ||
                      "")) ||
                  ((option) =>
                    (!item.data.lookup ? option : option.lookupItemName) || "")
                }
                getOptionSelected={
                  (item.field.FieldType === "searchField" &&
                    ((option) =>
                      (item.data.multi &&
                        item.data.multi === "true" &&
                        itemValue &&
                        (
                          (!Array.isArray(itemValue) && [itemValue]) ||
                          itemValue
                        ).findIndex(
                          (element) =>
                            (element &&
                              element.id &&
                              element.id === option.id) ||
                            option === element
                        ) !== -1) ||
                      (itemValue?.id && itemValue?.id === option?.id) ||
                      option === itemValue)) ||
                  ((option) =>
                    (item.data.multi &&
                      item.data.multi === "true" &&
                      (
                        (itemValue &&
                          ((item.field.FieldType === "UploadFiles" &&
                            itemValue &&
                            itemValue.selected &&
                            itemValue.selected.length &&
                            itemValue.selected) ||
                            (!Array.isArray(itemValue) && [itemValue]) ||
                            itemValue)) ||
                        []
                      ).findIndex(
                        (element) =>
                          (element &&
                            element.lookupItemId &&
                            element.lookupItemId === option?.lookupItemId) ||
                          option === element
                      ) !== -1) ||
                    ((
                      (item.field.FieldType === "UploadFiles" &&
                        itemValue &&
                        itemValue.selected) ||
                      itemValue
                    )?.lookupItemId &&
                      (
                        (item.field.FieldType === "UploadFiles" &&
                          itemValue &&
                          itemValue.selected) ||
                        itemValue
                      )?.lookupItemId === option?.lookupItemId) ||
                    option === itemValue)
                }
                onChange={async (e, v) => {
                  if (item.data.isReadonly) return;
                  if (fieldWithPermissionsToEdit()) return;
                  if (
                    (item.field.id === "property_name" &&
                      item?.data?.DtoName === "property_name_unit_form") ||
                    (item.field.id === "property" &&
                      item.data.searchableKey === "property_inquiries")
                  ) {
                    const checkPropertyIsLock =
                      await OnPropertyChangeEffectOnUnitRule(
                        v,
                        allItems,
                        onValueChanged,
                        onItemChanged,
                        2,
                        item,
                        allItemsValues
                      );
                    if (
                      item.field.id === "property_name" &&
                      item?.data?.DtoName === "property_name_unit_form" &&
                      checkPropertyIsLock
                    ) {
                      setIsOpenPropertyLockMangaement(true);
                      onValueChanged(null);
                      return;
                    }
                  }

                  if (item.field.FieldType === "UploadFiles") {
                    if (v == null) {
                      onValueChanged(v);
                      return;
                    } else if (v && Array.isArray(v) && !v.length) {
                      onValueChanged(null);
                      return;
                    } else if (
                      v &&
                      Array.isArray(v) &&
                      v.length > 0 &&
                      itemValue
                    ) {
                      let newValuesUpdatedObj = {};
                      Object.keys(itemValue)
                        .filter((lookup) => lookup !== "selected")
                        .map((itemKey) => {
                          if (v.some((s) => s.lookupItemName === itemKey)) {
                            newValuesUpdatedObj[`${itemKey}`] =
                              itemValue[`${itemKey}`];
                          }
                        });
                      onValueChanged({ ...newValuesUpdatedObj, selected: v });
                      return;
                    }
                    onValueChanged({ ...itemValue, selected: v });
                    return;
                  }
                  const blockedAgentFields = ["referredto"];

                  if (blockedAgentFields.includes(item.field.id)) {
                    if (await checkAgentIsBlocked(v)) {
                      setIsAgentBlockedDialogOpen(true);
                      onValueChanged(null);
                      return;
                    }
                  }
                  if (item.field.id === "property_plan")
                    PropertyOwnerDependingOnRule2(v, allItems);

                  if (item.field.id === "property_owner")
                    PropertyOwnerRule(v, allItems, 2, onValueChanged);

                  if (
                    (item.field.id === "contact_name" &&
                      v &&
                      v.high_profile_management &&
                      v.high_profile_management === "Yes") ||
                    (item.field.id === "contact_name" &&
                      v &&
                      v.angry_bird &&
                      v.angry_bird === "Yes")
                  ) {
                    showWarn(
                      t(`${t("Shared:Whoa-hold-on-This-lead-seems-A-bit")}`)
                    );
                  }
                  if (
                    (id === "high_profile_management" && v && v === "Yes") ||
                    (id === "angry_bird" && v && v === "Yes")
                  ) {
                    setIsOpenHighProfileMangaement(true);
                    return;
                  }
                  if (id === "property_lock" && v && v === "Yes") {
                    setIsOpenPropertyLockMangaement(true);
                    return;
                  }

                  if (id === "contact_preference") {
                    ContactPreferenceRule(item, v, onValueChanged, 2);
                    return;
                  }
                  if (
                    item.field.id === "property_plan" &&
                    allItemsValues &&
                    allItemsValues.property_plan &&
                    allItemsValues.property_plan.lookupItemName === "Completed"
                  )
                    PropertyPlanRule(item, v, onValueChanged, 2);

                  if (
                    id === "is_mortgage" &&
                    item &&
                    item.data &&
                    item.data.specialKey === "is_mortgage_seeker_lead"
                  )
                    IsMortgageReletedModeOfPaymentRule(
                      item,
                      v,
                      onValueChanged,
                      2,
                      allItems
                    );

                  if (
                    id === "mode_of_payment" &&
                    item &&
                    item.data &&
                    item.data.DtoName === "mode_of_payment_seeker_lead"
                  )
                    ModeOfPaymentRule(item, v, onValueChanged, 2);

                  UnitRentedRule(item, v, onValueChanged, 2, allItemsValues);
                  FinancialStatusDetails2(
                    item,
                    v,
                    allItems,
                    allItemsValues,
                    onValueChanged
                  );
                  MortgageDetailsRules2(
                    item,
                    v,
                    onValueChanged,
                    allItems,
                    allItemsValues
                  );
                  if (
                    item.field.id === "bedrooms" ||
                    item.field.id === "bathrooms"
                  ) {
                    const findAnyBathroomsAndBedrooms = v.find(
                      (num) => num === "Any" || num === "any"
                    );
                    if (findAnyBathroomsAndBedrooms) {
                      onValueChanged([findAnyBathroomsAndBedrooms]);
                      return;
                    }
                  }
                  if (
                    item.field.id === "listing_expiry_period" ||
                    item.field.id === "rent_listing_expiry_period"
                  )
                    ListingDateRule2(
                      item,
                      v,
                      onValueChanged,
                      allItems,
                      allItemsValues
                    );
                  if (item.field.id === "status") {
                    if ((v && v.lookupItemName === "Open") || !v)
                      StatusLeadDefaulRule2(
                        item,
                        onValueChanged,
                        allItems,
                        allItemsValues
                      );
                  }

                  if (item.data.specialKey === "sendLeadToRotation")
                    RotationLeadRule(
                      item,
                      v,
                      onItemChanged,
                      allItems,
                      allItemsValues,
                      onValueChanged,
                      2
                    );
                  if (item.data.specialKey === "smartAssignmentLead")
                    AssignmentLeadRule(v, onValueChanged, allItems, 2);
                  if (item.field.id === "rental_plan")
                    rentalPlanRule(v, onValueChanged, allItems, 2);
                  if (item.data.specialKey === "sendInquiryToRotation")
                    InquirySendToRotationRule(
                      item,
                      v,
                      onItemChanged,
                      allItems,
                      allItemsValues,
                      onValueChanged,
                      2
                    );
                  if (
                    id === "unit_ref_number" &&
                    item &&
                    item.data &&
                    (item.data.DtoName === "unit_ref_number_sekeer_lead" ||
                      item.data.DtoName === "unit_ref_number_owner_lead")
                  )
                    UnitRefNumberRule(
                      item,
                      v,
                      allItems,
                      onValueChanged,
                      2,
                      allItemsValues
                    );

                  if (
                    id === "operation_type" &&
                    item &&
                    item.data &&
                    item.data.DtoName === "operation_type_seeker_lead"
                  );
                  OnChangeOperationTypeForSeekerLead(
                    item,
                    v,
                    allItems,
                    onValueChanged,
                    onItemChanged,
                    allItemsValues,
                    2
                  );
                  if (
                    id === "property_name" &&
                    item &&
                    item.data &&
                    (item.data.DtoName === "property_seeker_lead" ||
                      item.data.DtoName === "property_owner_lead")
                  )
                    OnChangePropertyOnLeadRule2(
                      item,
                      v,
                      allItems,
                      onValueChanged,
                      onItemChanged,
                      allItemsValues
                    );

                  if (
                    item.field.id === "unit_ref_number" &&
                    item.data.DtoName === "unit_ref_number_owner_lead"
                  )
                    UnitRefNumberLeadOwnerRule(
                      item,
                      allItems,
                      v,
                      allItemsValues,
                      onValueChanged,
                      2
                    );

                  if (
                    item.field.id === "property" &&
                    item.data.searchableKey === "property_inquiries"
                  )
                    onChangePropertyRule(
                      item,
                      v,
                      onItemChanged,
                      allItems,
                      2,
                      onValueChanged
                    );

                  if (item.field.id === "inquiry_unit_model")
                    UnitModelRule(
                      item,
                      v,
                      onItemChanged,
                      allItems,
                      onValueChanged,
                      2,
                      allItemsValues
                    );

                  if (item.field.id === "shortage_in")
                    ShortageInRule(allItems, onValueChanged, 2);
                  if (item.field.id === "lead_owner") {
                    if (v === null) {
                      setLeadOwnerValue(itemValue);
                      setIsOpenLeadOwnerDialog(true);
                    }
                  } else if (item.field.id === "lease_lead_owner") {
                    if (v === null) {
                      setLeaseLeadOwnerValue(itemValue);
                      setisOpenLeaseLeadOwnerDialog(true);
                    }
                  }

                  TitleRuleV2(id, onValueChanged, item, allItems, v);
                  OnchangePropertyInUnitRuleV2(item, v, onValueChanged);
                  LookupsEffectedOnRules(
                    v,
                    item,
                    onValueChanged,
                    onItemChanged,
                    allItems,
                    allItemsValues,
                    onLoadingsChanged
                  );

                  OnchangeCountryRule2(id, onValueChanged, item, allItems, v);
                  OnchangeCityRule2(
                    id,
                    v,
                    allItems,
                    onValueChanged,
                    item,
                    allItemsValues?.country
                  );
                  OnchangeDistrictRule2(
                    id,
                    onValueChanged,
                    item,
                    allItems,
                    v,
                    allItemsValues?.city
                  );
                  OnchangeCommunityRule2(
                    id,
                    onValueChanged,
                    item,
                    allItems,
                    v,
                    allItemsValues?.district
                  );
                  OnchangeSubCommunityRule2(
                    id,
                    onValueChanged,
                    item,
                    allItems,
                    v,
                    allItemsValues?.community
                  );
                  onValueChanged(v);
                  if (item.field.id === "branch_location") {
                    BranchLocationRule2(item, v, onValueChanged);
                  }
                }}
                withoutSearchButton
                buttonOptions={
                  (item.field.FieldType === "UploadFiles" && {
                    className: "btns-icon theme-solid bg-blue-lighter",
                    iconClasses:
                      item.field.id === "external_url"
                        ? "mdi mdi-plus"
                        : "mdi mdi-attachment",
                    isDisabled:
                      item.data.isReadonly ||
                      !(
                        itemValue &&
                        itemValue.selected &&
                        itemValue.selected.length > 0
                      ) ||
                      fieldWithPermissionsToEdit(),
                    isRequired: false,
                    onActionClicked: () => {
                      if (
                        itemValue &&
                        itemValue.selected &&
                        itemValue.selected.length > 0 &&
                        item.field.id !== "external_url"
                      )
                        setOpenUploadDialog(true);
                      if (
                        itemValue &&
                        itemValue.selected &&
                        itemValue.selected.length > 0 &&
                        item.field.id === "external_url"
                      ) {
                      }
                    },
                  }) ||
                  (item.field.FieldType === "searchField" &&
                    item.field.id !== "referredto" &&
                    item.field.id !== "referredby" &&
                    !(
                      item.field.id === "unit_ref_number" &&
                      isLeadOwnerForm &&
                      !itemValue
                    ) &&
                    item.field.id !== "listing_agent" &&
                    item.field.id !== "assign_to" &&
                    item.field.id !== "lead" &&
                    item.field.id !== "publishing_requester" &&
                    item.field.id !== "rent_listing_agent" &&
                    item.field.id !== "inquiry_unit_model" &&
                    item.field.id !== "campaign_name" &&
                     item.field.id !== "referred_by_contact" && 
                    item.field.id !== "psi_key_person" &&
                    item.field.id !== "branch_location" &&
                    item.field.id !== "lead_auditor" && {
                      className: "btns-icon theme-outline c-blue-lighter",
                      iconClasses: itemValue
                        ? "mdi mdi-eye-outline"
                        : "mdi mdi-plus",
                      isDisabled:
                        (item.data.multi && item.data.multi === "true") ||
                        item.field.id === "listing_agent",
                      isRequired: false,
                      onActionClicked: onSearchFieldActionClicked,
                    }) ||
                  undefined
                }
                labelValue={label}
              />
            ) : (
              <ReskinningAutocomplete
                rootCustomClasses={styles.fieldClasses}
                labelClasses={item.field.isRequired ? "c-red" : ""}
                idRef={item.field.id}
                isRequired={item.field.isRequired}
                isDisabled={
                  fieldWithPermissionsToEdit() ||
                  getStatusValue() ||
                  disableQualification() ||
                  getLeadOperationValue() ||
                  disableUnitRefNumber() ||
                  disableIsMortgageInTenant() ||
                  customerProfileSelected() ||
                  disableLead() ||
                  isLoading ||
                  item.data.isReadonly ||
                  item.data.specialKey === "IsDisabled" ||
                  item.data.specialKey === "UnitRefNo" ||
                  getSendLeadToRotationSelected() ||
                  getIsLeadAuditor() ||
                  disableContactRate() ||
                  disableRatingLead() ||
                  disableOperationType() ||
                  disableChangePropertyAge() ||
                  disableListingExpiryPeriod() ||
                  getSmartAssignmentSelected() ||
                  disableName()
                }
                isLoading={isLoading}
                withLoader
                isWithError
                isSubmitted={isSubmitted}
                helperText={helperText}
                error={error}
                multiple={
                  (item.data.multi && item.data.multi === "true") || false
                }
                filterOptions={
                  ((item.data.searchKey === "property" ||
                    item.data.searchKey === "contact" ||
                    item.data.searchKey === "Leads" ||
                    item.data.searchKey === "PropertyOrUnit" ||
                    item.data.searchKey === "developers") &&
                    ((option) => option)) ||
                  undefined
                }
                renderOption={
                  (item.data.searchKey === "property" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate fz-14px">
                          {option.name || ""}
                          <span className="fz-12px">{`${
                            option.property_plan
                              ? ` - ${option.property_plan}`
                              : ""
                          }`}</span>
                        </div>
                        <span className="c-gray-secondary fz-12px">
                          {`${option?.community?.lookupItemName || "N/A"} ${
                            option.subCommunity?.lookupItemName
                              ? `, ${option.subCommunity.lookupItemName}`
                              : ""
                          }`}
                        </span>
                      </div>
                    ))) ||
                  (item.data.searchKey === "User" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate">
                          {(option && option.name) ||
                            (option && option.fullName)}
                        </div>
                        <span className="c-gray-secondary">
                          {option.branch || ""}
                        </span>
                      </div>
                    ))) ||
                  (item.data.searchKey === "contact" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate">
                          {option.name}
                        </div>
                        <span className="c-gray-secondary">
                          {option.mobile}
                        </span>
                      </div>
                    ))) ||
                  (item.data.searchKey === "Leads" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate">
                          {option.name}
                        </div>
                        <span className="c-gray-secondary">
                          {option.leadClass}
                        </span>
                      </div>
                    ))) ||
                  (item.data.searchKey === "campaign_name" &&
                    ((option) => (
                      <div className="d-flex-column">
                        <div className="d-flex-v-center-h-between w-100 texts-truncate">
                          {option.name}
                        </div>
                      </div>
                    ))) ||
                  (item.data.searchKey === "PropertyOrUnit" &&
                    ((option) =>
                      (option.isProperty && (
                        <span>{`${option.name || ""} - ${
                          option.city || ""
                        }`}</span>
                      )) || (
                        <div className="d-flex-column">
                          <span>{`${option.unitModel} - ${option.name} - ${option.unitType}`}</span>
                          <span className="c-gray-secondary">
                            {`${option.unitBedrooms} - ${option.unitRefNo}`}
                          </span>
                        </div>
                      ))) ||
                  undefined
                }
                selectedValues={
                  item.data.multi && item.data.multi === "true"
                    ? (itemValue &&
                        item.field.FieldType === "UploadFiles" &&
                        itemValue &&
                        itemValue.selected &&
                        itemValue.selected.length > 0 && [
                          ...itemValue.selected,
                        ]) ||
                      (!itemValue && []) ||
                      (itemValue && Array.isArray(itemValue)
                        ? itemValue || []
                        : valueIsObjectBefore || []) ||
                      []
                    : itemValue || inputValue || null
                }
                data={getDataEnumList(item)}
                chipsLabel={
                  (item.data &&
                    item.data.multi &&
                    item.data.multi === "true" &&
                    ((item.field.FieldType === "searchField" &&
                      ((option) => (option && option.name) || "")) ||
                      ((option) =>
                        !item.data.lookup
                          ? option
                          : (option && option.lookupItemName) || undefined))) ||
                  undefined
                }
                onInputChange={
                  (item.field.FieldType === "searchField" &&
                    ((e, v) => {
                      ContactRule(item, v || inputValue, onItemChanged);
                      DeveloperContactRule(item, v, onItemChanged);
                      PropertyRule(item, v, onItemChanged);
                      UserRule(
                        item,
                        v,
                        onItemChanged,
                        allItems,
                        allItemsValues,
                        GetParams("activeFormType"),
                        2,
                        onvolumechange
                      );
                      LeadsRule(item, v, onItemChanged, typeOf, loginResponse);
                      PropertyOrUnitRule(
                        item,
                        v,
                        onItemChanged,
                        allItems,
                        allItemsValues
                      );
                      UnitRule(
                        item,
                        v,
                        onItemChanged,
                        allItems,
                        allItemsValues
                      );
                      CampaignsRule(item, v, onItemChanged);
                    })) ||
                  undefined
                }
                inputClasses="inputs theme-form-builder"
                displayLabel={
                  (item.field.FieldType === "searchField" &&
                    ((option) =>
                      (option && `${option.name} ${option.barnch || ""}`) ||
                      "")) ||
                  ((option) =>
                    (!item.data.lookup ? option : option.lookupItemName) || "")
                }
                getOptionSelected={
                  (item.field.FieldType === "searchField" &&
                    ((option) =>
                      (item.data.multi &&
                        item.data.multi === "true" &&
                        itemValue &&
                        (
                          (!Array.isArray(itemValue) && [itemValue]) ||
                          itemValue
                        ).findIndex(
                          (element) =>
                            (element &&
                              element.id &&
                              element.id === option.id) ||
                            option === element
                        ) !== -1) ||
                      (itemValue?.id && itemValue?.id === option?.id) ||
                      option === itemValue)) ||
                  ((option) =>
                    (item.data.multi &&
                      item.data.multi === "true" &&
                      (
                        (itemValue &&
                          ((item.field.FieldType === "UploadFiles" &&
                            itemValue &&
                            itemValue.selected &&
                            itemValue.selected.length &&
                            itemValue.selected) ||
                            (!Array.isArray(itemValue) && [itemValue]) ||
                            itemValue)) ||
                        []
                      ).findIndex(
                        (element) =>
                          (element &&
                            element.lookupItemId &&
                            element.lookupItemId === option?.lookupItemId) ||
                          option === element
                      ) !== -1) ||
                    ((
                      (item.field.FieldType === "UploadFiles" &&
                        itemValue &&
                        itemValue.selected) ||
                      itemValue
                    )?.lookupItemId &&
                      (
                        (item.field.FieldType === "UploadFiles" &&
                          itemValue &&
                          itemValue.selected) ||
                        itemValue
                      )?.lookupItemId === option?.lookupItemId) ||
                    option === itemValue)
                }
                onChange={async (e, v) => {
                  if (v === null || v === undefined) setInputValue("");

                  if (item.data.isReadonly) return;
                  if (fieldWithPermissionsToEdit()) return;
                  if (
                    (item.field.id === "property_name" &&
                      item?.data?.DtoName === "property_name_unit_form") ||
                    (item.field.id === "property" &&
                      item.data.searchableKey === "property_inquiries")
                  ) {
                    const checkPropertyIsLock =
                      await OnPropertyChangeEffectOnUnitRule(
                        v,
                        allItems,
                        onValueChanged,
                        onItemChanged,
                        2,
                        item,
                        allItemsValues
                      );
                    if (
                      item.field.id === "property_name" &&
                      item?.data?.DtoName === "property_name_unit_form" &&
                      checkPropertyIsLock
                    ) {
                      setIsOpenPropertyLockMangaement(true);
                      onValueChanged(null);
                      return;
                    }
                  }

                  if (item.field.FieldType === "UploadFiles") {
                    if (v == null) {
                      onValueChanged(v);
                      return;
                    } else if (v && Array.isArray(v) && !v.length) {
                      onValueChanged(null);
                      return;
                    } else if (
                      v &&
                      Array.isArray(v) &&
                      v.length > 0 &&
                      itemValue
                    ) {
                      let newValuesUpdatedObj = {};
                      Object.keys(itemValue)
                        .filter((lookup) => lookup !== "selected")
                        .map((itemKey) => {
                          if (v.some((s) => s.lookupItemName === itemKey)) {
                            newValuesUpdatedObj[`${itemKey}`] =
                              itemValue[`${itemKey}`];
                          }
                        });
                      onValueChanged({ ...newValuesUpdatedObj, selected: v });
                      return;
                    }
                    onValueChanged({ ...itemValue, selected: v });
                    return;
                  }
                  const blockedAgentFields = ["referredto"];

                  if (blockedAgentFields.includes(item.field.id)) {
                    if (await checkAgentIsBlocked(v)) {
                      setIsAgentBlockedDialogOpen(true);
                      onValueChanged(null);
                      return;
                    }
                  }
                  if (item.field.id === "property_plan")
                    PropertyOwnerDependingOnRule2(v, allItems);

                  if (item.field.id === "property_owner")
                    PropertyOwnerRule(v, allItems, 2, onValueChanged);

                  if (
                    (item.field.id === "contact_name" &&
                      v &&
                      v.high_profile_management &&
                      v.high_profile_management === "Yes") ||
                    (item.field.id === "contact_name" &&
                      v &&
                      v.angry_bird &&
                      v.angry_bird === "Yes")
                  ) {
                    showWarn(
                      t(`${t("Shared:Whoa-hold-on-This-lead-seems-A-bit")}`)
                    );
                  }
                  if (
                    (id === "high_profile_management" && v && v === "Yes") ||
                    (id === "angry_bird" && v && v === "Yes")
                  ) {
                    setIsOpenHighProfileMangaement(true);
                    return;
                  }
                  if (id === "property_lock" && v && v === "Yes") {
                    setIsOpenPropertyLockMangaement(true);
                    return;
                  }

                  if (id === "contact_preference") {
                    ContactPreferenceRule(item, v, onValueChanged, 2);
                    return;
                  }
                  if (
                    item.field.id === "property_plan" &&
                    allItemsValues &&
                    allItemsValues.property_plan &&
                    allItemsValues.property_plan.lookupItemName === "Completed"
                  )
                    PropertyPlanRule(item, v, onValueChanged, 2);

                  if (
                    id === "is_mortgage" &&
                    item &&
                    item.data &&
                    item.data.specialKey === "is_mortgage_seeker_lead"
                  )
                    IsMortgageReletedModeOfPaymentRule(
                      item,
                      v,
                      onValueChanged,
                      2,
                      allItems
                    );

                  if (
                    id === "mode_of_payment" &&
                    item &&
                    item.data &&
                    item.data.DtoName === "mode_of_payment_seeker_lead"
                  )
                    ModeOfPaymentRule(item, v, onValueChanged, 2);

                  UnitRentedRule(item, v, onValueChanged, 2, allItemsValues);
                  FinancialStatusDetails2(
                    item,
                    v,
                    allItems,
                    allItemsValues,
                    onValueChanged
                  );
                  MortgageDetailsRules2(
                    item,
                    v,
                    onValueChanged,
                    allItems,
                    allItemsValues
                  );
                  if (
                    item.field.id === "bedrooms" ||
                    item.field.id === "bathrooms"
                  ) {
                    const findAnyBathroomsAndBedrooms = v.find(
                      (num) => num === "Any" || num === "any"
                    );
                    if (findAnyBathroomsAndBedrooms) {
                      onValueChanged([findAnyBathroomsAndBedrooms]);
                      return;
                    }
                  }
                  if (
                    item.field.id === "listing_expiry_period" ||
                    item.field.id === "rent_listing_expiry_period"
                  )
                    ListingDateRule2(
                      item,
                      v,
                      onValueChanged,
                      allItems,
                      allItemsValues
                    );
                  if (item.field.id === "status") {
                    if ((v && v.lookupItemName === "Open") || !v)
                      StatusLeadDefaulRule2(
                        item,
                        onValueChanged,
                        allItems,
                        allItemsValues
                      );
                  }

                  if (item.data.specialKey === "sendLeadToRotation")
                    RotationLeadRule(
                      item,
                      v,
                      onItemChanged,
                      allItems,
                      allItemsValues,
                      onValueChanged,
                      2
                    );
                  if (item.data.specialKey === "smartAssignmentLead")
                    AssignmentLeadRule(v, onValueChanged, allItems, 2);
                  if (item.data.specialKey === "sendInquiryToRotation")
                    InquirySendToRotationRule(
                      item,
                      v,
                      onItemChanged,
                      allItems,
                      allItemsValues,
                      onValueChanged,
                      2
                    );
                  if (
                    id === "unit_ref_number" &&
                    item &&
                    item.data &&
                    (item.data.DtoName === "unit_ref_number_sekeer_lead" ||
                      item.data.DtoName === "unit_ref_number_owner_lead")
                  )
                    UnitRefNumberRule(
                      item,
                      v,
                      allItems,
                      onValueChanged,
                      2,
                      allItemsValues
                    );

                  if (
                    id === "operation_type" &&
                    item &&
                    item.data &&
                    item.data.DtoName === "operation_type_seeker_lead"
                  );
                  OnChangeOperationTypeForSeekerLead(
                    item,
                    v,
                    allItems,
                    onValueChanged,
                    onItemChanged,
                    allItemsValues,
                    2
                  );
                  if (
                    id === "property_name" &&
                    item &&
                    item.data &&
                    (item.data.DtoName === "property_seeker_lead" ||
                      item.data.DtoName === "property_owner_lead")
                  )
                    OnChangePropertyOnLeadRule2(
                      item,
                      v,
                      allItems,
                      onValueChanged,
                      onItemChanged,
                      allItemsValues
                    );

                  if (
                    item.field.id === "unit_ref_number" &&
                    item.data.DtoName === "unit_ref_number_owner_lead"
                  )
                    UnitRefNumberLeadOwnerRule(
                      item,
                      allItems,
                      v,
                      allItemsValues,
                      onValueChanged,
                      2
                    );

                  if (
                    item.field.id === "property" &&
                    item.data.searchableKey === "property_inquiries"
                  )
                    onChangePropertyRule(
                      item,
                      v,
                      onItemChanged,
                      allItems,
                      2,
                      onValueChanged
                    );

                  if (item.field.id === "inquiry_unit_model")
                    UnitModelRule(
                      item,
                      v,
                      onItemChanged,
                      allItems,
                      onValueChanged,
                      2,
                      allItemsValues
                    );

                  if (item.field.id === "shortage_in")
                    ShortageInRule(allItems, onValueChanged, 2);
                  if (item.field.id === "lead_owner") {
                    if (v === null) {
                      setLeadOwnerValue(itemValue);
                      setIsOpenLeadOwnerDialog(true);
                    }
                  } else if (item.field.id === "lease_lead_owner") {
                    if (v === null) {
                      setLeaseLeadOwnerValue(itemValue);
                      setisOpenLeaseLeadOwnerDialog(true);
                    }
                  }

                  TitleRuleV2(id, onValueChanged, item, allItems, v);
                  OnchangePropertyInUnitRuleV2(item, v, onValueChanged);
                  LookupsEffectedOnRules(
                    v,
                    item,
                    onValueChanged,
                    onItemChanged,
                    allItems,
                    allItemsValues,
                    onLoadingsChanged
                  );

                  OnchangeCountryRule2(id, onValueChanged, item, allItems, v);
                  OnchangeCityRule2(
                    id,
                    v,
                    allItems,
                    onValueChanged,
                    item,
                    allItemsValues?.country
                  );
                  OnchangeDistrictRule2(
                    id,
                    onValueChanged,
                    item,
                    allItems,
                    v,
                    allItemsValues?.city
                  );
                  OnchangeCommunityRule2(
                    id,
                    onValueChanged,
                    item,
                    allItems,
                    v,
                    allItemsValues?.district
                  );
                  OnchangeSubCommunityRule2(
                    id,
                    onValueChanged,
                    item,
                    allItems,
                    v,
                    allItemsValues?.community
                  );
                  onValueChanged(v);
                }}
                withoutSearchButton
                labelValue={label}
                helperInfo={item.data.HelperInfo}
                Icon={() => {
                  const isMulti = item.data.multi === "true";
                  const isDisabled =
                    isMulti || item.field.id === "listing_agent";
                  const IconComponent =
                    itemValue || inputValue ? EyeIcon : PlusIcon;
                  const fillColor = isDisabled
                    ? palette.foreground.disabled
                    : palette.button.secondary_fg;

                  return item.field.FieldType === "UploadFiles" ? (
                    <UploadIcon
                      width="20px"
                      height="20px"
                      fill={
                        !(
                          itemValue &&
                          itemValue.selected &&
                          itemValue.selected.length > 0
                        )
                          ? palette.foreground.disabled
                          : palette.button.secondary_fg
                      }
                      onClick={() => {
                        if (
                          itemValue &&
                          itemValue.selected &&
                          itemValue.selected.length > 0 &&
                          id !== "external_url"
                        )
                          setOpenUploadDialog(true);
                      }}
                      style={{
                        marginLeft: "8px",
                        display: "flex",
                        alignSelf: "center",
                        cursor: !(
                          itemValue &&
                          itemValue.selected &&
                          itemValue.selected.length > 0
                        )
                          ? "not-allowed"
                          : "pointer",
                      }}
                    />
                  ) : (
                    (item.field.FieldType === "searchField" &&
                      item.field.id !== "referredto" &&
                      item.field.id !== "referredby" &&
                      !(
                        item.field.id === "unit_ref_number" &&
                        isLeadOwnerForm &&
                        !itemValue
                      ) &&
                      item.field.id !== "listing_agent" &&
                      item.field.id !== "assign_to" &&
                      item.field.id !== "lead" &&
                      item.field.id !== "publishing_requester" &&
                      item.field.id !== "rent_listing_agent" &&
                      item.field.id !== "inquiry_unit_model" &&
                      item.field.id !== "campaign_name" &&
                      item.field.id !== "referred_by_contact" &&
                      item.field.id !== "psi_key_person" &&
                      item.field.id !== "lead_auditor" && (
                        <IconComponent
                          width="20px"
                          height="20px"
                          fill={fillColor}
                          onClick={onSearchFieldActionClicked}
                          style={{
                            marginLeft: "8px",
                            display: "flex",
                            alignSelf: "center",
                            cursor: isDisabled ? "not-allowed" : "pointer",
                          }}
                        />
                      )) ||
                      null
                  );
                }}
              />
            )}
            {(item?.data?.pendingFieldsHelperInfo?.trim() ||
              item?.data?.HelperInfo?.trim()) &&
              !isNewLayout && (
                <div className="information-open-file-2">
                  <Tooltip
                    size="large"
                    title={
                      item?.data?.pendingFieldsHelperInfo ||
                      item.data.HelperInfo
                    }
                    className={item.data.className ? item.data.className : ""}
                  >
                    <span className="mdi mdi-information-outline" />
                  </Tooltip>
                </div>
              )}
          </div>
        )}
      {/* /************************ display colse reason when lead status  is closed only  ************************** */}
      {displySelectFields() && (
        <div className="form-item">
          <AutocompleteComponent
            labelClasses={item.field.isRequired ? "c-red" : ""}
            idRef={item.field.id}
            isRequired={item.field.isRequired}
            isDisabled={
              getIsUpdateCloseResonAndRemarks() ||
              saleTypeOwnerlead() ||
              isLoading ||
              fieldWithPermissionsToEdit() ||
              disableName()
            }
            isLoading={isLoading}
            withLoader
            isWithError
            isSubmitted={isSubmitted}
            helperText={helperText}
            error={error}
            multiple={(item.data.multi && item.data.multi === "true") || false}
            filterOptions={
              ((item.data.searchKey === "property" ||
                item.data.searchKey === "contact" ||
                item.data.searchKey === "PropertyOrUnit") &&
                ((option) => option)) ||
              undefined
            }
            renderOption={
              (item.data.searchKey === "property" &&
                ((option) => (
                  <span>{`${option.name || ""} - ${option.city || ""}`}</span>
                ))) ||
              (item.data.searchKey === "contact" &&
                ((option) => (
                  <div className="d-flex-column">
                    <div className="d-flex-v-center-h-between w-100 texts-truncate">
                      {option.name}
                    </div>
                    <span className="c-gray-secondary">{option.phone}</span>
                  </div>
                ))) ||
              (item.data.searchKey === "PropertyOrUnit" &&
                ((option) =>
                  (option.isProperty && (
                    <span>{`${option.name || ""} - ${option.city || ""}`}</span>
                  )) || (
                    <div className="d-flex-column">
                      <span>{`${option.unitModel} - ${option.name} - ${option.unitType}`}</span>
                      <span className="c-gray-secondary">
                        {`${option.unitBedrooms} - ${option.unitRefNo}`}
                      </span>
                    </div>
                  ))) ||
              undefined
            }
            selectedValues={
              item.data.multi && item.data.multi === "true"
                ? (itemValue &&
                    ((item.field.FieldType === "UploadFiles" &&
                      itemValue &&
                      itemValue.selected && [...itemValue.selected]) ||
                      (!Array.isArray(itemValue) && [itemValue]) || [
                        ...itemValue,
                      ])) ||
                  []
                : itemValue || null
            }
            data={item.data.enum}
            chipsLabel={
              (item.data &&
                item.data.multi &&
                item.data.multi === "true" &&
                ((item.field.FieldType === "searchField" &&
                  ((option) => (option && option.name) || "")) ||
                  ((option) =>
                    !item.data.lookup
                      ? option
                      : (option && option.lookupItemName) || undefined))) ||
              undefined
            }
            onInputChange={
              (item.field.FieldType === "searchField" &&
                ((e, v) => {
                  ContactRule(item, v, onItemChanged);
                  DeveloperContactRule(item, v, onItemChanged);
                  PropertyRule(item, v, onItemChanged);
                  UserRule(item, v, onItemChanged, allItems, allItemsValues);
                  LeadsRule(item, v, onItemChanged, null, loginResponse);
                  PropertyOrUnitRule(
                    item,
                    v,
                    onItemChanged,
                    allItems,
                    allItemsValues
                  );
                })) ||
              undefined
            }
            inputClasses="inputs theme-form-builder"
            displayLabel={
              (item.field.FieldType === "searchField" &&
                ((option) => (option && option.name) || "")) ||
              ((option) =>
                (!item.data.lookup ? option : option.lookupItemName) || "")
            }
            getOptionSelected={
              (item.field.FieldType === "searchField" &&
                ((option) =>
                  (item.data.multi &&
                    item.data.multi === "true" &&
                    itemValue &&
                    (
                      (!Array.isArray(itemValue) && [itemValue]) ||
                      itemValue
                    ).findIndex(
                      (element) =>
                        (element && element.id && element.id === option.id) ||
                        option === element
                    ) !== -1) ||
                  (itemValue.id && itemValue.id === option.id) ||
                  option === itemValue)) ||
              ((option) =>
                (item.data.multi &&
                  item.data.multi === "true" &&
                  (
                    (itemValue &&
                      ((item.field.FieldType === "UploadFiles" &&
                        itemValue &&
                        itemValue.selected) ||
                        (!Array.isArray(itemValue) && [itemValue]) ||
                        itemValue)) ||
                    []
                  ).findIndex(
                    (element) =>
                      (element &&
                        element.lookupItemId &&
                        element.lookupItemId === option.lookupItemId) ||
                      option === element
                  ) !== -1) ||
                ((
                  (item.field.FieldType === "UploadFiles" &&
                    itemValue &&
                    itemValue.selected) ||
                  itemValue
                ).lookupItemId &&
                  (
                    (item.field.FieldType === "UploadFiles" &&
                      itemValue &&
                      itemValue.selected) ||
                    itemValue
                  ).lookupItemId === option.lookupItemId) ||
                option === itemValue)
            }
            onChange={(e, v) => {
              if (item.data.isReadonly) return;
              if (isSelectDisallowed(v)) return;
              if (fieldWithPermissionsToEdit()) return;

              if (
                item.field.id === "bedrooms" ||
                item.field.id === "bathrooms"
              ) {
                const findAnyBathroomsAndBedrooms = v.find(
                  (num) => num === "Any" || num === "any"
                );
                if (findAnyBathroomsAndBedrooms) {
                  onValueChanged([findAnyBathroomsAndBedrooms]);
                  return;
                }
              }
              TitleRuleV2(id, onValueChanged, item, allItems, v);
              OnchangePropertyInUnitRuleV2(item, v, onValueChanged);
              if (item.field.FieldType === "UploadFiles")
                onValueChanged({ ...itemValue, selected: v });
              else onValueChanged(v);
              LookupsEffectedOnRules(
                v,
                item,
                onValueChanged,
                onItemChanged,
                allItems,
                allItemsValues,
                onLoadingsChanged
              );
            }}
            withoutSearchButton
            buttonOptions={
              (item.field.FieldType === "UploadFiles" && {
                className: "btns-icon theme-solid bg-blue-lighter",
                iconClasses:
                  item.field.id === "external_url"
                    ? "mdi mdi-plus"
                    : "mdi mdi-attachment",
                isDisabled: true,
                isRequired: false,
                onActionClicked: () => {
                  if (
                    itemValue &&
                    itemValue.selected &&
                    itemValue.selected.length > 0 &&
                    item.field.id !== "external_url"
                  )
                    setOpenUploadDialog(true);
                  if (
                    itemValue &&
                    itemValue.selected &&
                    itemValue.selected.length > 0 &&
                    item.field.id === "external_url"
                  )
                    setRepeatedLinkDialog(true);
                },
              }) ||
              (item.field.FieldType === "searchField" &&
                item.field.id !== "referredto" && 
                item.field.id !== "referred_by_contact" && 
                item.field.id !== "referredby" && {
                  className: "btns-icon theme-outline c-blue-lighter",
                  iconClasses: itemValue
                    ? "mdi mdi-eye-outline"
                    : "mdi mdi-plus",
                  isDisabled:
                    (item.data.multi && item.data.multi === "true") ||
                    item.field.id === "listing_agent",
                  isRequired: false,
                  onActionClicked: onSearchFieldActionClicked,
                }) ||
              undefined
            }
            labelValue={label}
          />

          {(item?.data?.pendingFieldsHelperInfo?.trim() ||
            item?.data?.HelperInfo?.trim()) && (
            <div className="information-open-file-1">
              <Tooltip
                size="large"
                title={
                  item?.data?.pendingFieldsHelperInfo || item.data.HelperInfo
                }
                className={item.data.className ? item.data.className : ""}
              >
                <span className="mdi mdi-information-outline" />
              </Tooltip>
            </div>
          )}
        </div>
      )}

      {item.field.FieldType === "PriceAndPercentage" && (
        <PriceAndPercentage
          type={item.data.controlType}
          itemIsSensitive={item.data.isReadonly || false}
          allItemsValues={allItemsValues}
          onValueChanged={onValueChanged}
          currency="AED"
          value={itemValue}
          onChange={(e) => {
            if (e === null) return;
            onValueChanged(e);
          }}
          depositSum={
            item.data.controlType === "Rent Type" &&
            RentDeposit2(allItemsValues, onValueChanged, 2, allItems)
          }
          hideDeposit={hideDeposit}
          canChange={canChange || false}
        />
      )}

      {itemValue &&
        itemValue.selected &&
        itemValue.selected.length > 0 &&
        !isNewLayout && (
          <UploadDialog
            open={openUploadDialog}
            onChange={(e, isClearAll) => {
              if (isClearAll) {
                onValueChanged({ selected: e.selected });
                return;
              } else {
                let newValuesUpdatedObj = {};
                Object.keys(e)
                  .filter((lookup) => lookup !== "selected")
                  .map((itemKey) => {
                    if (e.selected?.some((s) => s.lookupItemName === itemKey)) {
                      newValuesUpdatedObj[`${itemKey}`] = e[`${itemKey}`];
                    }
                  });
                onValueChanged({
                  ...newValuesUpdatedObj,
                  selected: itemValue.selected || [],
                });
                return;
              }
            }}
            initialState={itemValue}
            closeDialog={() => {
              setOpenUploadDialog(false);
            }}
          />
        )}
      {isNewLayout &&
        item.field.FieldType === "UploadFiles" &&
        openUploadDialog &&
        itemValue?.selected &&
        itemValue.selected.length > 0 && (
          <ContactUploadDocumentStep
            open={openUploadDialog}
            uploadedImageFile={uploadedImageFile}
            setUploadedImageFile={setUploadedImageFile}
            uploadedLogoFile={uploadedLogoFile}
            setUploadedLogoFile={setUploadedLogoFile}
            close={() => {
              setOpenUploadDialog(false);
            }}
            translate={translate}
            onValueChanged={onValueChanged}
            index={item.field.id}
            itemValue={itemValue}
            formType={+GetParams("formType")}
            initialState={itemValue}
            isCompanyOptions={item.data?.enum.some((s) =>
              s?.lookupItemName.includes("Company")
            )}
            isMultiple
          />
        )}

      {openMapDialog && !isNewLayout && (
        <MapDialog
          open={openMapDialog}
          onChange={(e) => {
            onValueChanged({ ...e });
          }}
          initialState={itemValue}
          closeDialog={() => {
            setOpenMapDialog(false);
          }}
        />
      )}

      {itemValue && itemValue.Models && (
        <ModelsUnitsDialog
          initialState={itemValue}
          items={item.data.enum}
          open={modelsUnitsDialog}
          closeDialog={() => {
            setModelsUnitsDialog(false);
          }}
          onChange={(value) => {
            onValueChanged({
              ...value,
              Models: itemValue.Models,
            });
          }}
        />
      )}

      <ContactsDialog
        open={isOpenContactsDialog && !isNewLayout}
        onSave={() => {}}
        closeDialog={() => {
          setIsOpenContactsDialog(false);
        }}
        isViewContact={itemValue}
        isOpenInsideForm={isOpenContactsDialog}
        item={item}
      />

      {isOpenAddDeveloperDialog && (
        <AddDeveloperComponent
          isOpen={isOpenAddDeveloperDialog}
          onClose={() => setIsOpenAddDeveloperDialog(false)}
          onSave={() => {
            setIsOpenAddDeveloperDialog(false);
          }}
        />
      )}

      {isOpenItemDetails && (
        <DetailsDialog
          isOpen={isOpenItemDetails}
          isOpenChanged={() => {
            setIsOpenItemDetails(false);
            setIsLoadingDetailsDialog(false);
            setIsSensitiveLoading2(0);
          }}
          isLoadingDetailsDialog={isLoadingDetailsDialog}
          isOpenInsideForm={isOpenItemDetails}
          dataInSideViewButton={dataInSideViewButton}
          sensitiveFieldsForUser={sensitiveFieldsForUser2}
          isSensitiveLoading={isSensitiveLoading2}
          unitOpertaionTypeValue={
            unitOperationTypeField ||
            (allItemsValues &&
              allItemsValues.operation_type &&
              allItemsValues.operation_type.lookupItemId)
          }
        />
      )}

      {isNotHavePolicyToDisplayData && (
        <NotHavePolicyToDisplayDataDialog
          isOpen={isNotHavePolicyToDisplayData}
          isOpenChanged={() => {
            setIsNotHavePolicyToDisplayData(false);
          }}
        />
      )}

      {RepeatedDialog && (
        <RepeatedItemDialog
          open={RepeatedDialog}
          item={item}
          type={(item.data.CommunicationType === "Email" && "email") || "phone"}
          initialState={itemValue}
          label={label}
          closeDialog={() => {
            setRepeatedDialog(false);
          }}
          selectedValues={allItemsValues}
          itemList={allItems}
          onChange={
            (item.data.CommunicationType === "Email" &&
              ((value) => {
                onValueChanged({
                  ...value,
                  email: itemValue.email,
                  typeId: item.data.lookupItem,
                });
              })) ||
            ((newValue) => {
              onValueChanged({
                ...newValue,
                phone: itemValue.phone,
                typeId: item.data.lookupItem,
              });
            })
          }
        />
      )}

      {repeatedLinkDialog && (
        <RepeatedLinkDialog
          item={item}
          itemList={allItems}
          label={label}
          initialState={itemValue}
          open={repeatedLinkDialog}
          selectedValues={allItemsValues}
          onChange={(newValue) => {
            onValueChanged({
              ...newValue,
            });
          }}
          closeDialog={() => setRepeatedLinkDialog(false)}
        />
      )}

      {isOpenLeadOwnerDialog && (
        <LeadOwnerDialog
          open={isOpenLeadOwnerDialog}
          onSave={() => setIsOpenLeadOwnerDialog(false)}
          close={() => {
            onValueChanged(leadOwnerValue, 0, "lead_owner");
            setIsOpenLeadOwnerDialog(false);
          }}
        />
      )}

      {isOpenLeaseLeadOwnerDialog && (
        <LeaseLeadOwnerDialog
          open={isOpenLeaseLeadOwnerDialog}
          onSave={() => setisOpenLeaseLeadOwnerDialog(false)}
          close={() => {
            onValueChanged(leadOwnerValue, 0, "lease_lead_owner");
            setisOpenLeaseLeadOwnerDialog(false);
          }}
        />
      )}

      {isNotHavePolicyToDisplayData && (
        <NotHavePolicyToDisplayDataDialog
          isOpen={isNotHavePolicyToDisplayData}
          isOpenChanged={() => {
            setIsNotHavePolicyToDisplayData(false);
          }}
        />
      )}

      {isOpenHighProfileMangaement && (
        <HighPofileManagementDialog
          isOpenDialog={isOpenHighProfileMangaement}
          onClose={() => setIsOpenHighProfileMangaement(false)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onCancelClicked={() => {
            setIsOpenHighProfileMangaement(false);
          }}
          onSave={() => {
            onValueChanged("Yes", null, item.field.id);
          }}
        />
      )}

      {isOpenPropertyLockMangaement && (
        <PropertyLockManagementDialog
          filedName={id}
          isOpenDialog={isOpenPropertyLockMangaement}
          onClose={() => setIsOpenPropertyLockMangaement(false)}
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onCancelClicked={() => {
            setIsOpenPropertyLockMangaement(false);
          }}
          onSave={() => {
            if (item.field.id === "property_lock")
              if (onValueChanged && item?.field?.id)
                onValueChanged("Yes", null, item.field.id);
          }}
        />
      )}
      {isAgentBlockedDialogOpen && (
        <MessageConfirmDialog
          isDialogOpen={isAgentBlockedDialogOpen}
          theme="warning"
          cancelButton={{
            label: "Discard",
            handler: () => {
              setIsAgentBlockedDialogOpen(false);
            },
          }}
          content={{
            heading: t("agent-blocked"),
            body: t("the-selected-agent-is-blocked"),
          }}
        />
      )}
    </>
  );
};

const convertJsonItemShape = PropTypes.shape({
  data: PropTypes.shape({
    enum: PropTypes.instanceOf(Array),
    CommunicationType: PropTypes.string,
    searchKey: PropTypes.string,
    title: PropTypes.string,
    regExp: PropTypes.string,
    dependOn: PropTypes.string,
    uiType: PropTypes.string,
    defaultCountryCode: PropTypes.string,
    minNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isReadonly: PropTypes.bool,
    maxDate: PropTypes.string,
    minDate: PropTypes.string,
    lookup: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    controlType: PropTypes.string,
    multi: PropTypes.oneOf(['true', 'false']),
    lookupItem: PropTypes.number,
    items: PropTypes.shape({
      enum: PropTypes.instanceOf(Array),
    }),
  }),
  field: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    FieldType: PropTypes.string,
    isRequired: PropTypes.bool,
  }),
});

const convertJsonValueShape = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
  PropTypes.bool,
  PropTypes.instanceOf(Object),
  PropTypes.instanceOf(Array),
]);

ConvertJsonV2Component.propTypes = {
  item: convertJsonItemShape.isRequired,
  itemValue: convertJsonValueShape,
  allItems: PropTypes.arrayOf(convertJsonItemShape).isRequired,
  allItemsValues: PropTypes.objectOf(convertJsonValueShape).isRequired,
  onItemChanged: PropTypes.func.isRequired,
  onValueChanged: PropTypes.func.isRequired,
  helperText: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  onLoadingsChanged: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hideDeposit: PropTypes.bool,
  typeOf: PropTypes.string,
  isOpenInsideForm: PropTypes.bool,
};

ConvertJsonV2Component.defaultProps = {
  itemValue: undefined,
  hideDeposit: false,
  typeOf: '',
  isOpenInsideForm: false,
};
